/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const onTenantCreateContact = /* GraphQL */ `
  subscription OnTenantCreateContact($tenant: ID!) {
    onTenantCreateContact(tenant: $tenant) {
      id
      tenant
      externalId
      firstName
      lastName
      source
      phone
      cell
      email
      dateCreated
      address1
      address2
      city
      state
      zip
      country
      dnc
      updatedBy
      customFields
      expireDt
      outboundCallerId
      assignedAgent
      balances {
        id
        type
        amount
        age
      }
      timeZone
      timeZoneBounds {
        min {
          offset
          dst
        }
        max {
          offset
          dst
        }
      }
      type
      optOuts {
        voice
        sms
        email
      }
      optIns {
        voice
        sms
        email
      }
      attempts
      createdAt
      updatedAt
    }
  }
`;
export const onTenantUpdateContact = /* GraphQL */ `
  subscription OnTenantUpdateContact($tenant: ID!) {
    onTenantUpdateContact(tenant: $tenant) {
      id
      tenant
      externalId
      firstName
      lastName
      source
      phone
      cell
      email
      dateCreated
      address1
      address2
      city
      state
      zip
      country
      dnc
      updatedBy
      customFields
      expireDt
      outboundCallerId
      assignedAgent
      balances {
        id
        type
        amount
        age
      }
      timeZone
      timeZoneBounds {
        min {
          offset
          dst
        }
        max {
          offset
          dst
        }
      }
      type
      optOuts {
        voice
        sms
        email
      }
      optIns {
        voice
        sms
        email
      }
      attempts
      createdAt
      updatedAt
    }
  }
`;
export const onTenantDeleteContact = /* GraphQL */ `
  subscription OnTenantDeleteContact($tenant: ID!) {
    onTenantDeleteContact(tenant: $tenant) {
      id
      tenant
      externalId
      firstName
      lastName
      source
      phone
      cell
      email
      dateCreated
      address1
      address2
      city
      state
      zip
      country
      dnc
      updatedBy
      customFields
      expireDt
      outboundCallerId
      assignedAgent
      balances {
        id
        type
        amount
        age
      }
      timeZone
      timeZoneBounds {
        min {
          offset
          dst
        }
        max {
          offset
          dst
        }
      }
      type
      optOuts {
        voice
        sms
        email
      }
      optIns {
        voice
        sms
        email
      }
      attempts
      createdAt
      updatedAt
    }
  }
`;
export const onTenantCreateSegment = /* GraphQL */ `
  subscription OnTenantCreateSegment($tenant: ID!) {
    onTenantCreateSegment(tenant: $tenant) {
      id
      tenant
      externalId
      name
      description
      query {
        qbQuery
        searchFilter
        sort {
          field
          direction
        }
      }
      filter {
        qbQuery
        searchFilter
        sort {
          field
          direction
        }
      }
      fieldsMappingId
      suppressionID
      suppression {
        id
        tenant
        name
        checks {
          activityLogQuerySuppression {
            query
            rawQuery
            threshold
            result
          }
          pocQuerySuppression {
            query
            rawQuery
            suppressIfWeekendAndCantCallOnWeekends
            result
          }
          restSuppression {
            endpoint
            method
            params {
              key
              value
              description
            }
            headers {
              key
              value
              description
            }
            auth {
              type
              info
            }
            response {
              path
              type
              value
              options
            }
            suppressOnError
            dispositionOnError
            result
          }
          dncDotComSuppression {
            scrub
            state
            numberReassignment
            knownLitigator
            reassignmentSince
            checkOnlyFresh
            result
          }
          dncListSuppressions {
            dncs
            result
          }
          contactFieldSuppressions {
            contactFieldSuppressions
            result
          }
        }
        updatedBy
        createdAt
        updatedAt
      }
      updatedBy
      createdAt
      updatedAt
    }
  }
`;
export const onTenantUpdateSegment = /* GraphQL */ `
  subscription OnTenantUpdateSegment($tenant: ID!) {
    onTenantUpdateSegment(tenant: $tenant) {
      id
      tenant
      externalId
      name
      description
      query {
        qbQuery
        searchFilter
        sort {
          field
          direction
        }
      }
      filter {
        qbQuery
        searchFilter
        sort {
          field
          direction
        }
      }
      fieldsMappingId
      suppressionID
      suppression {
        id
        tenant
        name
        checks {
          activityLogQuerySuppression {
            query
            rawQuery
            threshold
            result
          }
          pocQuerySuppression {
            query
            rawQuery
            suppressIfWeekendAndCantCallOnWeekends
            result
          }
          restSuppression {
            endpoint
            method
            params {
              key
              value
              description
            }
            headers {
              key
              value
              description
            }
            auth {
              type
              info
            }
            response {
              path
              type
              value
              options
            }
            suppressOnError
            dispositionOnError
            result
          }
          dncDotComSuppression {
            scrub
            state
            numberReassignment
            knownLitigator
            reassignmentSince
            checkOnlyFresh
            result
          }
          dncListSuppressions {
            dncs
            result
          }
          contactFieldSuppressions {
            contactFieldSuppressions
            result
          }
        }
        updatedBy
        createdAt
        updatedAt
      }
      updatedBy
      createdAt
      updatedAt
    }
  }
`;
export const onTenantDeleteSegment = /* GraphQL */ `
  subscription OnTenantDeleteSegment($tenant: ID!) {
    onTenantDeleteSegment(tenant: $tenant) {
      id
      tenant
      externalId
      name
      description
      query {
        qbQuery
        searchFilter
        sort {
          field
          direction
        }
      }
      filter {
        qbQuery
        searchFilter
        sort {
          field
          direction
        }
      }
      fieldsMappingId
      suppressionID
      suppression {
        id
        tenant
        name
        checks {
          activityLogQuerySuppression {
            query
            rawQuery
            threshold
            result
          }
          pocQuerySuppression {
            query
            rawQuery
            suppressIfWeekendAndCantCallOnWeekends
            result
          }
          restSuppression {
            endpoint
            method
            params {
              key
              value
              description
            }
            headers {
              key
              value
              description
            }
            auth {
              type
              info
            }
            response {
              path
              type
              value
              options
            }
            suppressOnError
            dispositionOnError
            result
          }
          dncDotComSuppression {
            scrub
            state
            numberReassignment
            knownLitigator
            reassignmentSince
            checkOnlyFresh
            result
          }
          dncListSuppressions {
            dncs
            result
          }
          contactFieldSuppressions {
            contactFieldSuppressions
            result
          }
        }
        updatedBy
        createdAt
        updatedAt
      }
      updatedBy
      createdAt
      updatedAt
    }
  }
`;
export const onTenantCreateActivityLog = /* GraphQL */ `
  subscription OnTenantCreateActivityLog($tenant: ID!) {
    onTenantCreateActivityLog(tenant: $tenant) {
      id
      tenant
      type
      disposition
      title
      body
      activityLogContactId
      contact {
        id
        tenant
        externalId
        firstName
        lastName
        source
        phone
        cell
        email
        dateCreated
        address1
        address2
        city
        state
        zip
        country
        dnc
        updatedBy
        customFields
        expireDt
        outboundCallerId
        assignedAgent
        balances {
          id
          type
          amount
          age
        }
        timeZone
        timeZoneBounds {
          min {
            offset
            dst
          }
          max {
            offset
            dst
          }
        }
        type
        optOuts {
          voice
          sms
          email
        }
        optIns {
          voice
          sms
          email
        }
        attempts
        createdAt
        updatedAt
      }
      segment {
        id
        tenant
        externalId
        name
        description
        query {
          qbQuery
          searchFilter
          sort {
            field
            direction
          }
        }
        filter {
          qbQuery
          searchFilter
          sort {
            field
            direction
          }
        }
        fieldsMappingId
        suppressionID
        suppression {
          id
          tenant
          name
          checks {
            activityLogQuerySuppression {
              query
              rawQuery
              threshold
              result
            }
            pocQuerySuppression {
              query
              rawQuery
              suppressIfWeekendAndCantCallOnWeekends
              result
            }
            restSuppression {
              endpoint
              method
              params {
                key
                value
                description
              }
              headers {
                key
                value
                description
              }
              auth {
                type
                info
              }
              response {
                path
                type
                value
                options
              }
              suppressOnError
              dispositionOnError
              result
            }
            dncDotComSuppression {
              scrub
              state
              numberReassignment
              knownLitigator
              reassignmentSince
              checkOnlyFresh
              result
            }
            dncListSuppressions {
              dncs
              result
            }
            contactFieldSuppressions {
              contactFieldSuppressions
              result
            }
          }
          updatedBy
          createdAt
          updatedAt
        }
        updatedBy
        createdAt
        updatedAt
      }
      campaign {
        id
        tenant
        name
        segments
        segmentSchedule
        campaignSchedule
        reportSchedule
        static
        sort
        skillId
        skillName
        skillSource
        campaignProfileId
        profile {
          id
          tenant
          name
          useAi
          flowRatio
          scrubber {
            cell
            natDnc
            stateDnc
            orgDnc
            phoneDup
            contactDup
          }
          retry {
            minDuration
            maxAttempts
            maxContacts
            custRetry
            ratio
          }
          ai {
            org
            system
          }
          pushContacts
          startTime
          endTime
          buffer
          channels {
            type
            order
            retryDelay
            maxAttempts
            maxContacts
            custRetry
            paymentProfileId
            paymentProfileName
            dispositions
            cadence
            dialingScript
          }
          ratio
          dontCallOnWeekends
          callWindow {
            days
            tmz {
              offset
              dst
            }
            beginTime {
              hour
              minute
            }
            endTime {
              hour
              minute
            }
            callWindowQuery {
              field
              operator
              value
            }
            default
            order
          }
          clickToCall
          clickToCallOptions {
            dialMode
            allowManualNumberEntry
            allowMultipleCallsPerContact
          }
          previewDialing
          previewConfig
          callWindows {
            days
            tmz {
              offset
              dst
            }
            beginTime {
              hour
              minute
            }
            endTime {
              hour
              minute
            }
            callWindowQuery {
              field
              operator
              value
            }
            default
            order
          }
          dispositionScoring {
            noAnswer
            answer
            noAgentAvailableToDial
            noAgentOnAnswer
            overApproving
          }
          overrideDispositionScoring
          overrideDialToAgentRatio
          dialToAgentRatio
          freshLIFO
          retryLIFO
          thresholdDialing
          threshold
          thresholdMinimum
          thresholdBatchSize
          updatedBy
          createdAt
          updatedAt
        }
        status
        expireDate
        stopOnCompletion
        cci
        autoMode
        cciMetaData
        callerIdConfigurationId
        callbackConfigurationId
        updatedBy
        createdAt
        updatedAt
      }
      agent
      contactStatus
      timestamp
      metaData
      provider
      c2aId
      pocActual
      outboundCallerId
      callDurationSeconds
      ttl
      createdAt
      updatedAt
      activityLogSegmentId
      activityLogCampaignId
    }
  }
`;
export const onTenantUpdateActivityLog = /* GraphQL */ `
  subscription OnTenantUpdateActivityLog($tenant: ID!) {
    onTenantUpdateActivityLog(tenant: $tenant) {
      id
      tenant
      type
      disposition
      title
      body
      activityLogContactId
      contact {
        id
        tenant
        externalId
        firstName
        lastName
        source
        phone
        cell
        email
        dateCreated
        address1
        address2
        city
        state
        zip
        country
        dnc
        updatedBy
        customFields
        expireDt
        outboundCallerId
        assignedAgent
        balances {
          id
          type
          amount
          age
        }
        timeZone
        timeZoneBounds {
          min {
            offset
            dst
          }
          max {
            offset
            dst
          }
        }
        type
        optOuts {
          voice
          sms
          email
        }
        optIns {
          voice
          sms
          email
        }
        attempts
        createdAt
        updatedAt
      }
      segment {
        id
        tenant
        externalId
        name
        description
        query {
          qbQuery
          searchFilter
          sort {
            field
            direction
          }
        }
        filter {
          qbQuery
          searchFilter
          sort {
            field
            direction
          }
        }
        fieldsMappingId
        suppressionID
        suppression {
          id
          tenant
          name
          checks {
            activityLogQuerySuppression {
              query
              rawQuery
              threshold
              result
            }
            pocQuerySuppression {
              query
              rawQuery
              suppressIfWeekendAndCantCallOnWeekends
              result
            }
            restSuppression {
              endpoint
              method
              params {
                key
                value
                description
              }
              headers {
                key
                value
                description
              }
              auth {
                type
                info
              }
              response {
                path
                type
                value
                options
              }
              suppressOnError
              dispositionOnError
              result
            }
            dncDotComSuppression {
              scrub
              state
              numberReassignment
              knownLitigator
              reassignmentSince
              checkOnlyFresh
              result
            }
            dncListSuppressions {
              dncs
              result
            }
            contactFieldSuppressions {
              contactFieldSuppressions
              result
            }
          }
          updatedBy
          createdAt
          updatedAt
        }
        updatedBy
        createdAt
        updatedAt
      }
      campaign {
        id
        tenant
        name
        segments
        segmentSchedule
        campaignSchedule
        reportSchedule
        static
        sort
        skillId
        skillName
        skillSource
        campaignProfileId
        profile {
          id
          tenant
          name
          useAi
          flowRatio
          scrubber {
            cell
            natDnc
            stateDnc
            orgDnc
            phoneDup
            contactDup
          }
          retry {
            minDuration
            maxAttempts
            maxContacts
            custRetry
            ratio
          }
          ai {
            org
            system
          }
          pushContacts
          startTime
          endTime
          buffer
          channels {
            type
            order
            retryDelay
            maxAttempts
            maxContacts
            custRetry
            paymentProfileId
            paymentProfileName
            dispositions
            cadence
            dialingScript
          }
          ratio
          dontCallOnWeekends
          callWindow {
            days
            tmz {
              offset
              dst
            }
            beginTime {
              hour
              minute
            }
            endTime {
              hour
              minute
            }
            callWindowQuery {
              field
              operator
              value
            }
            default
            order
          }
          clickToCall
          clickToCallOptions {
            dialMode
            allowManualNumberEntry
            allowMultipleCallsPerContact
          }
          previewDialing
          previewConfig
          callWindows {
            days
            tmz {
              offset
              dst
            }
            beginTime {
              hour
              minute
            }
            endTime {
              hour
              minute
            }
            callWindowQuery {
              field
              operator
              value
            }
            default
            order
          }
          dispositionScoring {
            noAnswer
            answer
            noAgentAvailableToDial
            noAgentOnAnswer
            overApproving
          }
          overrideDispositionScoring
          overrideDialToAgentRatio
          dialToAgentRatio
          freshLIFO
          retryLIFO
          thresholdDialing
          threshold
          thresholdMinimum
          thresholdBatchSize
          updatedBy
          createdAt
          updatedAt
        }
        status
        expireDate
        stopOnCompletion
        cci
        autoMode
        cciMetaData
        callerIdConfigurationId
        callbackConfigurationId
        updatedBy
        createdAt
        updatedAt
      }
      agent
      contactStatus
      timestamp
      metaData
      provider
      c2aId
      pocActual
      outboundCallerId
      callDurationSeconds
      ttl
      createdAt
      updatedAt
      activityLogSegmentId
      activityLogCampaignId
    }
  }
`;
export const onTenantDeleteActivityLog = /* GraphQL */ `
  subscription OnTenantDeleteActivityLog($tenant: ID!) {
    onTenantDeleteActivityLog(tenant: $tenant) {
      id
      tenant
      type
      disposition
      title
      body
      activityLogContactId
      contact {
        id
        tenant
        externalId
        firstName
        lastName
        source
        phone
        cell
        email
        dateCreated
        address1
        address2
        city
        state
        zip
        country
        dnc
        updatedBy
        customFields
        expireDt
        outboundCallerId
        assignedAgent
        balances {
          id
          type
          amount
          age
        }
        timeZone
        timeZoneBounds {
          min {
            offset
            dst
          }
          max {
            offset
            dst
          }
        }
        type
        optOuts {
          voice
          sms
          email
        }
        optIns {
          voice
          sms
          email
        }
        attempts
        createdAt
        updatedAt
      }
      segment {
        id
        tenant
        externalId
        name
        description
        query {
          qbQuery
          searchFilter
          sort {
            field
            direction
          }
        }
        filter {
          qbQuery
          searchFilter
          sort {
            field
            direction
          }
        }
        fieldsMappingId
        suppressionID
        suppression {
          id
          tenant
          name
          checks {
            activityLogQuerySuppression {
              query
              rawQuery
              threshold
              result
            }
            pocQuerySuppression {
              query
              rawQuery
              suppressIfWeekendAndCantCallOnWeekends
              result
            }
            restSuppression {
              endpoint
              method
              params {
                key
                value
                description
              }
              headers {
                key
                value
                description
              }
              auth {
                type
                info
              }
              response {
                path
                type
                value
                options
              }
              suppressOnError
              dispositionOnError
              result
            }
            dncDotComSuppression {
              scrub
              state
              numberReassignment
              knownLitigator
              reassignmentSince
              checkOnlyFresh
              result
            }
            dncListSuppressions {
              dncs
              result
            }
            contactFieldSuppressions {
              contactFieldSuppressions
              result
            }
          }
          updatedBy
          createdAt
          updatedAt
        }
        updatedBy
        createdAt
        updatedAt
      }
      campaign {
        id
        tenant
        name
        segments
        segmentSchedule
        campaignSchedule
        reportSchedule
        static
        sort
        skillId
        skillName
        skillSource
        campaignProfileId
        profile {
          id
          tenant
          name
          useAi
          flowRatio
          scrubber {
            cell
            natDnc
            stateDnc
            orgDnc
            phoneDup
            contactDup
          }
          retry {
            minDuration
            maxAttempts
            maxContacts
            custRetry
            ratio
          }
          ai {
            org
            system
          }
          pushContacts
          startTime
          endTime
          buffer
          channels {
            type
            order
            retryDelay
            maxAttempts
            maxContacts
            custRetry
            paymentProfileId
            paymentProfileName
            dispositions
            cadence
            dialingScript
          }
          ratio
          dontCallOnWeekends
          callWindow {
            days
            tmz {
              offset
              dst
            }
            beginTime {
              hour
              minute
            }
            endTime {
              hour
              minute
            }
            callWindowQuery {
              field
              operator
              value
            }
            default
            order
          }
          clickToCall
          clickToCallOptions {
            dialMode
            allowManualNumberEntry
            allowMultipleCallsPerContact
          }
          previewDialing
          previewConfig
          callWindows {
            days
            tmz {
              offset
              dst
            }
            beginTime {
              hour
              minute
            }
            endTime {
              hour
              minute
            }
            callWindowQuery {
              field
              operator
              value
            }
            default
            order
          }
          dispositionScoring {
            noAnswer
            answer
            noAgentAvailableToDial
            noAgentOnAnswer
            overApproving
          }
          overrideDispositionScoring
          overrideDialToAgentRatio
          dialToAgentRatio
          freshLIFO
          retryLIFO
          thresholdDialing
          threshold
          thresholdMinimum
          thresholdBatchSize
          updatedBy
          createdAt
          updatedAt
        }
        status
        expireDate
        stopOnCompletion
        cci
        autoMode
        cciMetaData
        callerIdConfigurationId
        callbackConfigurationId
        updatedBy
        createdAt
        updatedAt
      }
      agent
      contactStatus
      timestamp
      metaData
      provider
      c2aId
      pocActual
      outboundCallerId
      callDurationSeconds
      ttl
      createdAt
      updatedAt
      activityLogSegmentId
      activityLogCampaignId
    }
  }
`;
export const onTenantCreateTenantSettings = /* GraphQL */ `
  subscription OnTenantCreateTenantSettings($id: ID!) {
    onTenantCreateTenantSettings(id: $id) {
      id
      icApp
      icVendor
      icBU
      icUserName
      icPassword
      icGetAuthTokenURL
      icAccessKey
      icAppSecret
      icDiscoveryDomain
      icScriptName
      ftpImport
      ftpExport
      dashBoardCharts
      e2DashCharts
      ppDashCharts
      e2ClientId
      e2ClientSecret
      e2DynamTenantId
      onPremAccessUrl
      onPremVersion
      onPremAuthUrl
      apiKey
      licenses
      customFields {
        name
        displayName
        type
        isPoc
      }
      dynamicsConnection
      dynamicsDispoFilter
      email
      dispositionScoring {
        noAnswer
        answer
        noAgentAvailableToDial
        noAgentOnAnswer
        overApproving
      }
      telephonyProvider
      telephoneProviderInfo {
        amazonConnect {
          accessKey
          secretKey
          instanceId
          region
          queueId
          transferFlowId
        }
        incontact {
          icApp
          icVendor
          icBU
          icUserName
          icPassword
          icGetAuthTokenURL
          icAccessKey
          icAppSecret
          icDiscoveryDomain
          icScriptName
        }
        nobelbiz {
          nobelbizTenantId
          token
          instanceId
          username
          password
          encodedAuth
        }
        genesys {
          clientId
          clientSecret
          cloudRegion
          queueId
          wrapUps
          timerFlow
          chime {
            region
            outboundDialNumber
            sipMediaApplicationId
          }
        }
        webex {
          contactCenter {
            region
            organizationId
            clientId
            clientSecret
            workspaceId
          }
          connect {
            region
            serviceKey
          }
          chime {
            region
            outboundDialNumber
            sipMediaApplicationId
          }
        }
        ringCX {
          clientId
          clientSecret
          serverUrl
          jwt
          adminAccountId
        }
      }
      dncDotComSettings {
        orgId
        projectId
        loginId
        scrubEnabled
        reassignmentEnabled
        knownLitigatorEnabled
      }
      ipAuthentication
      ipRanges
      allowAutoMode
      manualStrategy
      overrideDialToAgentRatio
      dialToAgentRatio
      country
      timeZone
      createdAt
      updatedAt
    }
  }
`;
export const onTenantUpdateTenantSettings = /* GraphQL */ `
  subscription OnTenantUpdateTenantSettings($id: ID!) {
    onTenantUpdateTenantSettings(id: $id) {
      id
      icApp
      icVendor
      icBU
      icUserName
      icPassword
      icGetAuthTokenURL
      icAccessKey
      icAppSecret
      icDiscoveryDomain
      icScriptName
      ftpImport
      ftpExport
      dashBoardCharts
      e2DashCharts
      ppDashCharts
      e2ClientId
      e2ClientSecret
      e2DynamTenantId
      onPremAccessUrl
      onPremVersion
      onPremAuthUrl
      apiKey
      licenses
      customFields {
        name
        displayName
        type
        isPoc
      }
      dynamicsConnection
      dynamicsDispoFilter
      email
      dispositionScoring {
        noAnswer
        answer
        noAgentAvailableToDial
        noAgentOnAnswer
        overApproving
      }
      telephonyProvider
      telephoneProviderInfo {
        amazonConnect {
          accessKey
          secretKey
          instanceId
          region
          queueId
          transferFlowId
        }
        incontact {
          icApp
          icVendor
          icBU
          icUserName
          icPassword
          icGetAuthTokenURL
          icAccessKey
          icAppSecret
          icDiscoveryDomain
          icScriptName
        }
        nobelbiz {
          nobelbizTenantId
          token
          instanceId
          username
          password
          encodedAuth
        }
        genesys {
          clientId
          clientSecret
          cloudRegion
          queueId
          wrapUps
          timerFlow
          chime {
            region
            outboundDialNumber
            sipMediaApplicationId
          }
        }
        webex {
          contactCenter {
            region
            organizationId
            clientId
            clientSecret
            workspaceId
          }
          connect {
            region
            serviceKey
          }
          chime {
            region
            outboundDialNumber
            sipMediaApplicationId
          }
        }
        ringCX {
          clientId
          clientSecret
          serverUrl
          jwt
          adminAccountId
        }
      }
      dncDotComSettings {
        orgId
        projectId
        loginId
        scrubEnabled
        reassignmentEnabled
        knownLitigatorEnabled
      }
      ipAuthentication
      ipRanges
      allowAutoMode
      manualStrategy
      overrideDialToAgentRatio
      dialToAgentRatio
      country
      timeZone
      createdAt
      updatedAt
    }
  }
`;
export const onTenantDeleteTenantSettings = /* GraphQL */ `
  subscription OnTenantDeleteTenantSettings($id: ID!) {
    onTenantDeleteTenantSettings(id: $id) {
      id
      icApp
      icVendor
      icBU
      icUserName
      icPassword
      icGetAuthTokenURL
      icAccessKey
      icAppSecret
      icDiscoveryDomain
      icScriptName
      ftpImport
      ftpExport
      dashBoardCharts
      e2DashCharts
      ppDashCharts
      e2ClientId
      e2ClientSecret
      e2DynamTenantId
      onPremAccessUrl
      onPremVersion
      onPremAuthUrl
      apiKey
      licenses
      customFields {
        name
        displayName
        type
        isPoc
      }
      dynamicsConnection
      dynamicsDispoFilter
      email
      dispositionScoring {
        noAnswer
        answer
        noAgentAvailableToDial
        noAgentOnAnswer
        overApproving
      }
      telephonyProvider
      telephoneProviderInfo {
        amazonConnect {
          accessKey
          secretKey
          instanceId
          region
          queueId
          transferFlowId
        }
        incontact {
          icApp
          icVendor
          icBU
          icUserName
          icPassword
          icGetAuthTokenURL
          icAccessKey
          icAppSecret
          icDiscoveryDomain
          icScriptName
        }
        nobelbiz {
          nobelbizTenantId
          token
          instanceId
          username
          password
          encodedAuth
        }
        genesys {
          clientId
          clientSecret
          cloudRegion
          queueId
          wrapUps
          timerFlow
          chime {
            region
            outboundDialNumber
            sipMediaApplicationId
          }
        }
        webex {
          contactCenter {
            region
            organizationId
            clientId
            clientSecret
            workspaceId
          }
          connect {
            region
            serviceKey
          }
          chime {
            region
            outboundDialNumber
            sipMediaApplicationId
          }
        }
        ringCX {
          clientId
          clientSecret
          serverUrl
          jwt
          adminAccountId
        }
      }
      dncDotComSettings {
        orgId
        projectId
        loginId
        scrubEnabled
        reassignmentEnabled
        knownLitigatorEnabled
      }
      ipAuthentication
      ipRanges
      allowAutoMode
      manualStrategy
      overrideDialToAgentRatio
      dialToAgentRatio
      country
      timeZone
      createdAt
      updatedAt
    }
  }
`;
export const onTenantCreateCampaign = /* GraphQL */ `
  subscription OnTenantCreateCampaign($tenant: ID!) {
    onTenantCreateCampaign(tenant: $tenant) {
      id
      tenant
      name
      segments
      segmentSchedule
      campaignSchedule
      reportSchedule
      static
      sort
      skillId
      skillName
      skillSource
      campaignProfileId
      profile {
        id
        tenant
        name
        useAi
        flowRatio
        scrubber {
          cell
          natDnc
          stateDnc
          orgDnc
          phoneDup
          contactDup
        }
        retry {
          minDuration
          maxAttempts
          maxContacts
          custRetry
          ratio
        }
        ai {
          org
          system
        }
        pushContacts
        startTime
        endTime
        buffer
        channels {
          type
          order
          retryDelay
          maxAttempts
          maxContacts
          custRetry
          paymentProfileId
          paymentProfileName
          dispositions
          cadence
          dialingScript
        }
        ratio
        dontCallOnWeekends
        callWindow {
          days
          tmz {
            offset
            dst
          }
          beginTime {
            hour
            minute
          }
          endTime {
            hour
            minute
          }
          callWindowQuery {
            field
            operator
            value
          }
          default
          order
        }
        clickToCall
        clickToCallOptions {
          dialMode
          allowManualNumberEntry
          allowMultipleCallsPerContact
        }
        previewDialing
        previewConfig
        callWindows {
          days
          tmz {
            offset
            dst
          }
          beginTime {
            hour
            minute
          }
          endTime {
            hour
            minute
          }
          callWindowQuery {
            field
            operator
            value
          }
          default
          order
        }
        dispositionScoring {
          noAnswer
          answer
          noAgentAvailableToDial
          noAgentOnAnswer
          overApproving
        }
        overrideDispositionScoring
        overrideDialToAgentRatio
        dialToAgentRatio
        freshLIFO
        retryLIFO
        thresholdDialing
        threshold
        thresholdMinimum
        thresholdBatchSize
        updatedBy
        createdAt
        updatedAt
      }
      status
      expireDate
      stopOnCompletion
      cci
      autoMode
      cciMetaData
      callerIdConfigurationId
      callbackConfigurationId
      updatedBy
      createdAt
      updatedAt
    }
  }
`;
export const onTenantUpdateCampaign = /* GraphQL */ `
  subscription OnTenantUpdateCampaign($tenant: ID!) {
    onTenantUpdateCampaign(tenant: $tenant) {
      id
      tenant
      name
      segments
      segmentSchedule
      campaignSchedule
      reportSchedule
      static
      sort
      skillId
      skillName
      skillSource
      campaignProfileId
      profile {
        id
        tenant
        name
        useAi
        flowRatio
        scrubber {
          cell
          natDnc
          stateDnc
          orgDnc
          phoneDup
          contactDup
        }
        retry {
          minDuration
          maxAttempts
          maxContacts
          custRetry
          ratio
        }
        ai {
          org
          system
        }
        pushContacts
        startTime
        endTime
        buffer
        channels {
          type
          order
          retryDelay
          maxAttempts
          maxContacts
          custRetry
          paymentProfileId
          paymentProfileName
          dispositions
          cadence
          dialingScript
        }
        ratio
        dontCallOnWeekends
        callWindow {
          days
          tmz {
            offset
            dst
          }
          beginTime {
            hour
            minute
          }
          endTime {
            hour
            minute
          }
          callWindowQuery {
            field
            operator
            value
          }
          default
          order
        }
        clickToCall
        clickToCallOptions {
          dialMode
          allowManualNumberEntry
          allowMultipleCallsPerContact
        }
        previewDialing
        previewConfig
        callWindows {
          days
          tmz {
            offset
            dst
          }
          beginTime {
            hour
            minute
          }
          endTime {
            hour
            minute
          }
          callWindowQuery {
            field
            operator
            value
          }
          default
          order
        }
        dispositionScoring {
          noAnswer
          answer
          noAgentAvailableToDial
          noAgentOnAnswer
          overApproving
        }
        overrideDispositionScoring
        overrideDialToAgentRatio
        dialToAgentRatio
        freshLIFO
        retryLIFO
        thresholdDialing
        threshold
        thresholdMinimum
        thresholdBatchSize
        updatedBy
        createdAt
        updatedAt
      }
      status
      expireDate
      stopOnCompletion
      cci
      autoMode
      cciMetaData
      callerIdConfigurationId
      callbackConfigurationId
      updatedBy
      createdAt
      updatedAt
    }
  }
`;
export const onTenantDeleteCampaign = /* GraphQL */ `
  subscription OnTenantDeleteCampaign($tenant: ID!) {
    onTenantDeleteCampaign(tenant: $tenant) {
      id
      tenant
      name
      segments
      segmentSchedule
      campaignSchedule
      reportSchedule
      static
      sort
      skillId
      skillName
      skillSource
      campaignProfileId
      profile {
        id
        tenant
        name
        useAi
        flowRatio
        scrubber {
          cell
          natDnc
          stateDnc
          orgDnc
          phoneDup
          contactDup
        }
        retry {
          minDuration
          maxAttempts
          maxContacts
          custRetry
          ratio
        }
        ai {
          org
          system
        }
        pushContacts
        startTime
        endTime
        buffer
        channels {
          type
          order
          retryDelay
          maxAttempts
          maxContacts
          custRetry
          paymentProfileId
          paymentProfileName
          dispositions
          cadence
          dialingScript
        }
        ratio
        dontCallOnWeekends
        callWindow {
          days
          tmz {
            offset
            dst
          }
          beginTime {
            hour
            minute
          }
          endTime {
            hour
            minute
          }
          callWindowQuery {
            field
            operator
            value
          }
          default
          order
        }
        clickToCall
        clickToCallOptions {
          dialMode
          allowManualNumberEntry
          allowMultipleCallsPerContact
        }
        previewDialing
        previewConfig
        callWindows {
          days
          tmz {
            offset
            dst
          }
          beginTime {
            hour
            minute
          }
          endTime {
            hour
            minute
          }
          callWindowQuery {
            field
            operator
            value
          }
          default
          order
        }
        dispositionScoring {
          noAnswer
          answer
          noAgentAvailableToDial
          noAgentOnAnswer
          overApproving
        }
        overrideDispositionScoring
        overrideDialToAgentRatio
        dialToAgentRatio
        freshLIFO
        retryLIFO
        thresholdDialing
        threshold
        thresholdMinimum
        thresholdBatchSize
        updatedBy
        createdAt
        updatedAt
      }
      status
      expireDate
      stopOnCompletion
      cci
      autoMode
      cciMetaData
      callerIdConfigurationId
      callbackConfigurationId
      updatedBy
      createdAt
      updatedAt
    }
  }
`;
export const onTenantCreateProfile = /* GraphQL */ `
  subscription OnTenantCreateProfile($tenant: ID!) {
    onTenantCreateProfile(tenant: $tenant) {
      id
      tenant
      name
      useAi
      flowRatio
      scrubber {
        cell
        natDnc
        stateDnc
        orgDnc
        phoneDup
        contactDup
      }
      retry {
        minDuration
        maxAttempts
        maxContacts
        custRetry
        ratio
      }
      ai {
        org
        system
      }
      pushContacts
      startTime
      endTime
      buffer
      channels {
        type
        order
        retryDelay
        maxAttempts
        maxContacts
        custRetry
        paymentProfileId
        paymentProfileName
        dispositions
        cadence
        dialingScript
      }
      ratio
      dontCallOnWeekends
      callWindow {
        days
        tmz {
          offset
          dst
        }
        beginTime {
          hour
          minute
        }
        endTime {
          hour
          minute
        }
        callWindowQuery {
          field
          operator
          value
        }
        default
        order
      }
      clickToCall
      clickToCallOptions {
        dialMode
        allowManualNumberEntry
        allowMultipleCallsPerContact
      }
      previewDialing
      previewConfig
      callWindows {
        days
        tmz {
          offset
          dst
        }
        beginTime {
          hour
          minute
        }
        endTime {
          hour
          minute
        }
        callWindowQuery {
          field
          operator
          value
        }
        default
        order
      }
      dispositionScoring {
        noAnswer
        answer
        noAgentAvailableToDial
        noAgentOnAnswer
        overApproving
      }
      overrideDispositionScoring
      overrideDialToAgentRatio
      dialToAgentRatio
      freshLIFO
      retryLIFO
      thresholdDialing
      threshold
      thresholdMinimum
      thresholdBatchSize
      updatedBy
      createdAt
      updatedAt
    }
  }
`;
export const onTenantUpdateProfile = /* GraphQL */ `
  subscription OnTenantUpdateProfile($tenant: ID!) {
    onTenantUpdateProfile(tenant: $tenant) {
      id
      tenant
      name
      useAi
      flowRatio
      scrubber {
        cell
        natDnc
        stateDnc
        orgDnc
        phoneDup
        contactDup
      }
      retry {
        minDuration
        maxAttempts
        maxContacts
        custRetry
        ratio
      }
      ai {
        org
        system
      }
      pushContacts
      startTime
      endTime
      buffer
      channels {
        type
        order
        retryDelay
        maxAttempts
        maxContacts
        custRetry
        paymentProfileId
        paymentProfileName
        dispositions
        cadence
        dialingScript
      }
      ratio
      dontCallOnWeekends
      callWindow {
        days
        tmz {
          offset
          dst
        }
        beginTime {
          hour
          minute
        }
        endTime {
          hour
          minute
        }
        callWindowQuery {
          field
          operator
          value
        }
        default
        order
      }
      clickToCall
      clickToCallOptions {
        dialMode
        allowManualNumberEntry
        allowMultipleCallsPerContact
      }
      previewDialing
      previewConfig
      callWindows {
        days
        tmz {
          offset
          dst
        }
        beginTime {
          hour
          minute
        }
        endTime {
          hour
          minute
        }
        callWindowQuery {
          field
          operator
          value
        }
        default
        order
      }
      dispositionScoring {
        noAnswer
        answer
        noAgentAvailableToDial
        noAgentOnAnswer
        overApproving
      }
      overrideDispositionScoring
      overrideDialToAgentRatio
      dialToAgentRatio
      freshLIFO
      retryLIFO
      thresholdDialing
      threshold
      thresholdMinimum
      thresholdBatchSize
      updatedBy
      createdAt
      updatedAt
    }
  }
`;
export const onTenantDeleteProfile = /* GraphQL */ `
  subscription OnTenantDeleteProfile($tenant: ID!) {
    onTenantDeleteProfile(tenant: $tenant) {
      id
      tenant
      name
      useAi
      flowRatio
      scrubber {
        cell
        natDnc
        stateDnc
        orgDnc
        phoneDup
        contactDup
      }
      retry {
        minDuration
        maxAttempts
        maxContacts
        custRetry
        ratio
      }
      ai {
        org
        system
      }
      pushContacts
      startTime
      endTime
      buffer
      channels {
        type
        order
        retryDelay
        maxAttempts
        maxContacts
        custRetry
        paymentProfileId
        paymentProfileName
        dispositions
        cadence
        dialingScript
      }
      ratio
      dontCallOnWeekends
      callWindow {
        days
        tmz {
          offset
          dst
        }
        beginTime {
          hour
          minute
        }
        endTime {
          hour
          minute
        }
        callWindowQuery {
          field
          operator
          value
        }
        default
        order
      }
      clickToCall
      clickToCallOptions {
        dialMode
        allowManualNumberEntry
        allowMultipleCallsPerContact
      }
      previewDialing
      previewConfig
      callWindows {
        days
        tmz {
          offset
          dst
        }
        beginTime {
          hour
          minute
        }
        endTime {
          hour
          minute
        }
        callWindowQuery {
          field
          operator
          value
        }
        default
        order
      }
      dispositionScoring {
        noAnswer
        answer
        noAgentAvailableToDial
        noAgentOnAnswer
        overApproving
      }
      overrideDispositionScoring
      overrideDialToAgentRatio
      dialToAgentRatio
      freshLIFO
      retryLIFO
      thresholdDialing
      threshold
      thresholdMinimum
      thresholdBatchSize
      updatedBy
      createdAt
      updatedAt
    }
  }
`;
export const onTenantCreateCampaignLog = /* GraphQL */ `
  subscription OnTenantCreateCampaignLog($tenant: ID!) {
    onTenantCreateCampaignLog(tenant: $tenant) {
      id
      tenant
      campaign
      type
      metaData
      createdAt
      updatedAt
    }
  }
`;
export const onTenantUpdateCampaignLog = /* GraphQL */ `
  subscription OnTenantUpdateCampaignLog($tenant: ID!) {
    onTenantUpdateCampaignLog(tenant: $tenant) {
      id
      tenant
      campaign
      type
      metaData
      createdAt
      updatedAt
    }
  }
`;
export const onTenantDeleteCampaignLog = /* GraphQL */ `
  subscription OnTenantDeleteCampaignLog($tenant: ID!) {
    onTenantDeleteCampaignLog(tenant: $tenant) {
      id
      tenant
      campaign
      type
      metaData
      createdAt
      updatedAt
    }
  }
`;
export const onTenantCreateConfigProfile = /* GraphQL */ `
  subscription OnTenantCreateConfigProfile($tenant: ID!) {
    onTenantCreateConfigProfile(tenant: $tenant) {
      id
      tenant
      name
      direction
      mediaType
      crmEntity
      org {
        name
        id
        url
        version
      }
      connection {
        dynamicsTenant
        appSecret
        clientId
        altUrl
        authUrl
        onPremVersion
      }
      skillIds
      multiSearch
      search
      searchAction
      activityEntityMap
      logging
      postLogging
      loggingAction
      createdAt
      updatedAt
    }
  }
`;
export const onTenantUpdateConfigProfile = /* GraphQL */ `
  subscription OnTenantUpdateConfigProfile($tenant: ID!) {
    onTenantUpdateConfigProfile(tenant: $tenant) {
      id
      tenant
      name
      direction
      mediaType
      crmEntity
      org {
        name
        id
        url
        version
      }
      connection {
        dynamicsTenant
        appSecret
        clientId
        altUrl
        authUrl
        onPremVersion
      }
      skillIds
      multiSearch
      search
      searchAction
      activityEntityMap
      logging
      postLogging
      loggingAction
      createdAt
      updatedAt
    }
  }
`;
export const onTenantDeleteConfigProfile = /* GraphQL */ `
  subscription OnTenantDeleteConfigProfile($tenant: ID!) {
    onTenantDeleteConfigProfile(tenant: $tenant) {
      id
      tenant
      name
      direction
      mediaType
      crmEntity
      org {
        name
        id
        url
        version
      }
      connection {
        dynamicsTenant
        appSecret
        clientId
        altUrl
        authUrl
        onPremVersion
      }
      skillIds
      multiSearch
      search
      searchAction
      activityEntityMap
      logging
      postLogging
      loggingAction
      createdAt
      updatedAt
    }
  }
`;
export const onNotification = /* GraphQL */ `
  subscription OnNotification($tenant: ID!) {
    onNotification(tenant: $tenant) {
      id
      tenant
      cognitoId
      subject
      body
      link
      read
      ttl
      createdAt
      updatedAt
    }
  }
`;
export const onCreateTenantSettings = /* GraphQL */ `
  subscription OnCreateTenantSettings(
    $filter: ModelSubscriptionTenantSettingsFilterInput
  ) {
    onCreateTenantSettings(filter: $filter) {
      id
      icApp
      icVendor
      icBU
      icUserName
      icPassword
      icGetAuthTokenURL
      icAccessKey
      icAppSecret
      icDiscoveryDomain
      icScriptName
      ftpImport
      ftpExport
      dashBoardCharts
      e2DashCharts
      ppDashCharts
      e2ClientId
      e2ClientSecret
      e2DynamTenantId
      onPremAccessUrl
      onPremVersion
      onPremAuthUrl
      apiKey
      licenses
      customFields {
        name
        displayName
        type
        isPoc
      }
      dynamicsConnection
      dynamicsDispoFilter
      email
      dispositionScoring {
        noAnswer
        answer
        noAgentAvailableToDial
        noAgentOnAnswer
        overApproving
      }
      telephonyProvider
      telephoneProviderInfo {
        amazonConnect {
          accessKey
          secretKey
          instanceId
          region
          queueId
          transferFlowId
        }
        incontact {
          icApp
          icVendor
          icBU
          icUserName
          icPassword
          icGetAuthTokenURL
          icAccessKey
          icAppSecret
          icDiscoveryDomain
          icScriptName
        }
        nobelbiz {
          nobelbizTenantId
          token
          instanceId
          username
          password
          encodedAuth
        }
        genesys {
          clientId
          clientSecret
          cloudRegion
          queueId
          wrapUps
          timerFlow
          chime {
            region
            outboundDialNumber
            sipMediaApplicationId
          }
        }
        webex {
          contactCenter {
            region
            organizationId
            clientId
            clientSecret
            workspaceId
          }
          connect {
            region
            serviceKey
          }
          chime {
            region
            outboundDialNumber
            sipMediaApplicationId
          }
        }
        ringCX {
          clientId
          clientSecret
          serverUrl
          jwt
          adminAccountId
        }
      }
      dncDotComSettings {
        orgId
        projectId
        loginId
        scrubEnabled
        reassignmentEnabled
        knownLitigatorEnabled
      }
      ipAuthentication
      ipRanges
      allowAutoMode
      manualStrategy
      overrideDialToAgentRatio
      dialToAgentRatio
      country
      timeZone
      createdAt
      updatedAt
    }
  }
`;
export const onUpdateTenantSettings = /* GraphQL */ `
  subscription OnUpdateTenantSettings(
    $filter: ModelSubscriptionTenantSettingsFilterInput
  ) {
    onUpdateTenantSettings(filter: $filter) {
      id
      icApp
      icVendor
      icBU
      icUserName
      icPassword
      icGetAuthTokenURL
      icAccessKey
      icAppSecret
      icDiscoveryDomain
      icScriptName
      ftpImport
      ftpExport
      dashBoardCharts
      e2DashCharts
      ppDashCharts
      e2ClientId
      e2ClientSecret
      e2DynamTenantId
      onPremAccessUrl
      onPremVersion
      onPremAuthUrl
      apiKey
      licenses
      customFields {
        name
        displayName
        type
        isPoc
      }
      dynamicsConnection
      dynamicsDispoFilter
      email
      dispositionScoring {
        noAnswer
        answer
        noAgentAvailableToDial
        noAgentOnAnswer
        overApproving
      }
      telephonyProvider
      telephoneProviderInfo {
        amazonConnect {
          accessKey
          secretKey
          instanceId
          region
          queueId
          transferFlowId
        }
        incontact {
          icApp
          icVendor
          icBU
          icUserName
          icPassword
          icGetAuthTokenURL
          icAccessKey
          icAppSecret
          icDiscoveryDomain
          icScriptName
        }
        nobelbiz {
          nobelbizTenantId
          token
          instanceId
          username
          password
          encodedAuth
        }
        genesys {
          clientId
          clientSecret
          cloudRegion
          queueId
          wrapUps
          timerFlow
          chime {
            region
            outboundDialNumber
            sipMediaApplicationId
          }
        }
        webex {
          contactCenter {
            region
            organizationId
            clientId
            clientSecret
            workspaceId
          }
          connect {
            region
            serviceKey
          }
          chime {
            region
            outboundDialNumber
            sipMediaApplicationId
          }
        }
        ringCX {
          clientId
          clientSecret
          serverUrl
          jwt
          adminAccountId
        }
      }
      dncDotComSettings {
        orgId
        projectId
        loginId
        scrubEnabled
        reassignmentEnabled
        knownLitigatorEnabled
      }
      ipAuthentication
      ipRanges
      allowAutoMode
      manualStrategy
      overrideDialToAgentRatio
      dialToAgentRatio
      country
      timeZone
      createdAt
      updatedAt
    }
  }
`;
export const onDeleteTenantSettings = /* GraphQL */ `
  subscription OnDeleteTenantSettings(
    $filter: ModelSubscriptionTenantSettingsFilterInput
  ) {
    onDeleteTenantSettings(filter: $filter) {
      id
      icApp
      icVendor
      icBU
      icUserName
      icPassword
      icGetAuthTokenURL
      icAccessKey
      icAppSecret
      icDiscoveryDomain
      icScriptName
      ftpImport
      ftpExport
      dashBoardCharts
      e2DashCharts
      ppDashCharts
      e2ClientId
      e2ClientSecret
      e2DynamTenantId
      onPremAccessUrl
      onPremVersion
      onPremAuthUrl
      apiKey
      licenses
      customFields {
        name
        displayName
        type
        isPoc
      }
      dynamicsConnection
      dynamicsDispoFilter
      email
      dispositionScoring {
        noAnswer
        answer
        noAgentAvailableToDial
        noAgentOnAnswer
        overApproving
      }
      telephonyProvider
      telephoneProviderInfo {
        amazonConnect {
          accessKey
          secretKey
          instanceId
          region
          queueId
          transferFlowId
        }
        incontact {
          icApp
          icVendor
          icBU
          icUserName
          icPassword
          icGetAuthTokenURL
          icAccessKey
          icAppSecret
          icDiscoveryDomain
          icScriptName
        }
        nobelbiz {
          nobelbizTenantId
          token
          instanceId
          username
          password
          encodedAuth
        }
        genesys {
          clientId
          clientSecret
          cloudRegion
          queueId
          wrapUps
          timerFlow
          chime {
            region
            outboundDialNumber
            sipMediaApplicationId
          }
        }
        webex {
          contactCenter {
            region
            organizationId
            clientId
            clientSecret
            workspaceId
          }
          connect {
            region
            serviceKey
          }
          chime {
            region
            outboundDialNumber
            sipMediaApplicationId
          }
        }
        ringCX {
          clientId
          clientSecret
          serverUrl
          jwt
          adminAccountId
        }
      }
      dncDotComSettings {
        orgId
        projectId
        loginId
        scrubEnabled
        reassignmentEnabled
        knownLitigatorEnabled
      }
      ipAuthentication
      ipRanges
      allowAutoMode
      manualStrategy
      overrideDialToAgentRatio
      dialToAgentRatio
      country
      timeZone
      createdAt
      updatedAt
    }
  }
`;
export const onCreateFtpImport = /* GraphQL */ `
  subscription OnCreateFtpImport(
    $filter: ModelSubscriptionFtpImportFilterInput
  ) {
    onCreateFtpImport(filter: $filter) {
      id
      tenant
      name
      host
      username
      password
      path
      privateKey
      port
      fieldMappingId
      lastCheck
      fileNameToSource
      algorithms {
        cipher
      }
      readyTimeout
      reportEmail
      notificationGroup
      delimiter
      createdAt
      updatedAt
    }
  }
`;
export const onUpdateFtpImport = /* GraphQL */ `
  subscription OnUpdateFtpImport(
    $filter: ModelSubscriptionFtpImportFilterInput
  ) {
    onUpdateFtpImport(filter: $filter) {
      id
      tenant
      name
      host
      username
      password
      path
      privateKey
      port
      fieldMappingId
      lastCheck
      fileNameToSource
      algorithms {
        cipher
      }
      readyTimeout
      reportEmail
      notificationGroup
      delimiter
      createdAt
      updatedAt
    }
  }
`;
export const onDeleteFtpImport = /* GraphQL */ `
  subscription OnDeleteFtpImport(
    $filter: ModelSubscriptionFtpImportFilterInput
  ) {
    onDeleteFtpImport(filter: $filter) {
      id
      tenant
      name
      host
      username
      password
      path
      privateKey
      port
      fieldMappingId
      lastCheck
      fileNameToSource
      algorithms {
        cipher
      }
      readyTimeout
      reportEmail
      notificationGroup
      delimiter
      createdAt
      updatedAt
    }
  }
`;
export const onCreateFieldsMapping = /* GraphQL */ `
  subscription OnCreateFieldsMapping(
    $filter: ModelSubscriptionFieldsMappingFilterInput
  ) {
    onCreateFieldsMapping(filter: $filter) {
      id
      tenant
      name
      mappings {
        fromField
        toField
      }
      createdAt
      updatedAt
    }
  }
`;
export const onUpdateFieldsMapping = /* GraphQL */ `
  subscription OnUpdateFieldsMapping(
    $filter: ModelSubscriptionFieldsMappingFilterInput
  ) {
    onUpdateFieldsMapping(filter: $filter) {
      id
      tenant
      name
      mappings {
        fromField
        toField
      }
      createdAt
      updatedAt
    }
  }
`;
export const onDeleteFieldsMapping = /* GraphQL */ `
  subscription OnDeleteFieldsMapping(
    $filter: ModelSubscriptionFieldsMappingFilterInput
  ) {
    onDeleteFieldsMapping(filter: $filter) {
      id
      tenant
      name
      mappings {
        fromField
        toField
      }
      createdAt
      updatedAt
    }
  }
`;
export const onCreateContactMetadataFieldMappings = /* GraphQL */ `
  subscription OnCreateContactMetadataFieldMappings(
    $filter: ModelSubscriptionContactMetadataFieldMappingsFilterInput
  ) {
    onCreateContactMetadataFieldMappings(filter: $filter) {
      id
      tenant
      name
      mappings {
        fromField
        toField
      }
      createdAt
      updatedAt
    }
  }
`;
export const onUpdateContactMetadataFieldMappings = /* GraphQL */ `
  subscription OnUpdateContactMetadataFieldMappings(
    $filter: ModelSubscriptionContactMetadataFieldMappingsFilterInput
  ) {
    onUpdateContactMetadataFieldMappings(filter: $filter) {
      id
      tenant
      name
      mappings {
        fromField
        toField
      }
      createdAt
      updatedAt
    }
  }
`;
export const onDeleteContactMetadataFieldMappings = /* GraphQL */ `
  subscription OnDeleteContactMetadataFieldMappings(
    $filter: ModelSubscriptionContactMetadataFieldMappingsFilterInput
  ) {
    onDeleteContactMetadataFieldMappings(filter: $filter) {
      id
      tenant
      name
      mappings {
        fromField
        toField
      }
      createdAt
      updatedAt
    }
  }
`;
export const onCreateContactCallWindowsFieldMappings = /* GraphQL */ `
  subscription OnCreateContactCallWindowsFieldMappings(
    $filter: ModelSubscriptionContactCallWindowsFieldMappingsFilterInput
  ) {
    onCreateContactCallWindowsFieldMappings(filter: $filter) {
      id
      tenant
      name
      mappings {
        fromField
        toField
      }
      createdAt
      updatedAt
    }
  }
`;
export const onUpdateContactCallWindowsFieldMappings = /* GraphQL */ `
  subscription OnUpdateContactCallWindowsFieldMappings(
    $filter: ModelSubscriptionContactCallWindowsFieldMappingsFilterInput
  ) {
    onUpdateContactCallWindowsFieldMappings(filter: $filter) {
      id
      tenant
      name
      mappings {
        fromField
        toField
      }
      createdAt
      updatedAt
    }
  }
`;
export const onDeleteContactCallWindowsFieldMappings = /* GraphQL */ `
  subscription OnDeleteContactCallWindowsFieldMappings(
    $filter: ModelSubscriptionContactCallWindowsFieldMappingsFilterInput
  ) {
    onDeleteContactCallWindowsFieldMappings(filter: $filter) {
      id
      tenant
      name
      mappings {
        fromField
        toField
      }
      createdAt
      updatedAt
    }
  }
`;
export const onCreateContact = /* GraphQL */ `
  subscription OnCreateContact($filter: ModelSubscriptionContactFilterInput) {
    onCreateContact(filter: $filter) {
      id
      tenant
      externalId
      firstName
      lastName
      source
      phone
      cell
      email
      dateCreated
      address1
      address2
      city
      state
      zip
      country
      dnc
      updatedBy
      customFields
      expireDt
      outboundCallerId
      assignedAgent
      balances {
        id
        type
        amount
        age
      }
      timeZone
      timeZoneBounds {
        min {
          offset
          dst
        }
        max {
          offset
          dst
        }
      }
      type
      optOuts {
        voice
        sms
        email
      }
      optIns {
        voice
        sms
        email
      }
      attempts
      createdAt
      updatedAt
    }
  }
`;
export const onUpdateContact = /* GraphQL */ `
  subscription OnUpdateContact($filter: ModelSubscriptionContactFilterInput) {
    onUpdateContact(filter: $filter) {
      id
      tenant
      externalId
      firstName
      lastName
      source
      phone
      cell
      email
      dateCreated
      address1
      address2
      city
      state
      zip
      country
      dnc
      updatedBy
      customFields
      expireDt
      outboundCallerId
      assignedAgent
      balances {
        id
        type
        amount
        age
      }
      timeZone
      timeZoneBounds {
        min {
          offset
          dst
        }
        max {
          offset
          dst
        }
      }
      type
      optOuts {
        voice
        sms
        email
      }
      optIns {
        voice
        sms
        email
      }
      attempts
      createdAt
      updatedAt
    }
  }
`;
export const onDeleteContact = /* GraphQL */ `
  subscription OnDeleteContact($filter: ModelSubscriptionContactFilterInput) {
    onDeleteContact(filter: $filter) {
      id
      tenant
      externalId
      firstName
      lastName
      source
      phone
      cell
      email
      dateCreated
      address1
      address2
      city
      state
      zip
      country
      dnc
      updatedBy
      customFields
      expireDt
      outboundCallerId
      assignedAgent
      balances {
        id
        type
        amount
        age
      }
      timeZone
      timeZoneBounds {
        min {
          offset
          dst
        }
        max {
          offset
          dst
        }
      }
      type
      optOuts {
        voice
        sms
        email
      }
      optIns {
        voice
        sms
        email
      }
      attempts
      createdAt
      updatedAt
    }
  }
`;
export const onCreateCampaign = /* GraphQL */ `
  subscription OnCreateCampaign($filter: ModelSubscriptionCampaignFilterInput) {
    onCreateCampaign(filter: $filter) {
      id
      tenant
      name
      segments
      segmentSchedule
      campaignSchedule
      reportSchedule
      static
      sort
      skillId
      skillName
      skillSource
      campaignProfileId
      profile {
        id
        tenant
        name
        useAi
        flowRatio
        scrubber {
          cell
          natDnc
          stateDnc
          orgDnc
          phoneDup
          contactDup
        }
        retry {
          minDuration
          maxAttempts
          maxContacts
          custRetry
          ratio
        }
        ai {
          org
          system
        }
        pushContacts
        startTime
        endTime
        buffer
        channels {
          type
          order
          retryDelay
          maxAttempts
          maxContacts
          custRetry
          paymentProfileId
          paymentProfileName
          dispositions
          cadence
          dialingScript
        }
        ratio
        dontCallOnWeekends
        callWindow {
          days
          tmz {
            offset
            dst
          }
          beginTime {
            hour
            minute
          }
          endTime {
            hour
            minute
          }
          callWindowQuery {
            field
            operator
            value
          }
          default
          order
        }
        clickToCall
        clickToCallOptions {
          dialMode
          allowManualNumberEntry
          allowMultipleCallsPerContact
        }
        previewDialing
        previewConfig
        callWindows {
          days
          tmz {
            offset
            dst
          }
          beginTime {
            hour
            minute
          }
          endTime {
            hour
            minute
          }
          callWindowQuery {
            field
            operator
            value
          }
          default
          order
        }
        dispositionScoring {
          noAnswer
          answer
          noAgentAvailableToDial
          noAgentOnAnswer
          overApproving
        }
        overrideDispositionScoring
        overrideDialToAgentRatio
        dialToAgentRatio
        freshLIFO
        retryLIFO
        thresholdDialing
        threshold
        thresholdMinimum
        thresholdBatchSize
        updatedBy
        createdAt
        updatedAt
      }
      status
      expireDate
      stopOnCompletion
      cci
      autoMode
      cciMetaData
      callerIdConfigurationId
      callbackConfigurationId
      updatedBy
      createdAt
      updatedAt
    }
  }
`;
export const onUpdateCampaign = /* GraphQL */ `
  subscription OnUpdateCampaign($filter: ModelSubscriptionCampaignFilterInput) {
    onUpdateCampaign(filter: $filter) {
      id
      tenant
      name
      segments
      segmentSchedule
      campaignSchedule
      reportSchedule
      static
      sort
      skillId
      skillName
      skillSource
      campaignProfileId
      profile {
        id
        tenant
        name
        useAi
        flowRatio
        scrubber {
          cell
          natDnc
          stateDnc
          orgDnc
          phoneDup
          contactDup
        }
        retry {
          minDuration
          maxAttempts
          maxContacts
          custRetry
          ratio
        }
        ai {
          org
          system
        }
        pushContacts
        startTime
        endTime
        buffer
        channels {
          type
          order
          retryDelay
          maxAttempts
          maxContacts
          custRetry
          paymentProfileId
          paymentProfileName
          dispositions
          cadence
          dialingScript
        }
        ratio
        dontCallOnWeekends
        callWindow {
          days
          tmz {
            offset
            dst
          }
          beginTime {
            hour
            minute
          }
          endTime {
            hour
            minute
          }
          callWindowQuery {
            field
            operator
            value
          }
          default
          order
        }
        clickToCall
        clickToCallOptions {
          dialMode
          allowManualNumberEntry
          allowMultipleCallsPerContact
        }
        previewDialing
        previewConfig
        callWindows {
          days
          tmz {
            offset
            dst
          }
          beginTime {
            hour
            minute
          }
          endTime {
            hour
            minute
          }
          callWindowQuery {
            field
            operator
            value
          }
          default
          order
        }
        dispositionScoring {
          noAnswer
          answer
          noAgentAvailableToDial
          noAgentOnAnswer
          overApproving
        }
        overrideDispositionScoring
        overrideDialToAgentRatio
        dialToAgentRatio
        freshLIFO
        retryLIFO
        thresholdDialing
        threshold
        thresholdMinimum
        thresholdBatchSize
        updatedBy
        createdAt
        updatedAt
      }
      status
      expireDate
      stopOnCompletion
      cci
      autoMode
      cciMetaData
      callerIdConfigurationId
      callbackConfigurationId
      updatedBy
      createdAt
      updatedAt
    }
  }
`;
export const onDeleteCampaign = /* GraphQL */ `
  subscription OnDeleteCampaign($filter: ModelSubscriptionCampaignFilterInput) {
    onDeleteCampaign(filter: $filter) {
      id
      tenant
      name
      segments
      segmentSchedule
      campaignSchedule
      reportSchedule
      static
      sort
      skillId
      skillName
      skillSource
      campaignProfileId
      profile {
        id
        tenant
        name
        useAi
        flowRatio
        scrubber {
          cell
          natDnc
          stateDnc
          orgDnc
          phoneDup
          contactDup
        }
        retry {
          minDuration
          maxAttempts
          maxContacts
          custRetry
          ratio
        }
        ai {
          org
          system
        }
        pushContacts
        startTime
        endTime
        buffer
        channels {
          type
          order
          retryDelay
          maxAttempts
          maxContacts
          custRetry
          paymentProfileId
          paymentProfileName
          dispositions
          cadence
          dialingScript
        }
        ratio
        dontCallOnWeekends
        callWindow {
          days
          tmz {
            offset
            dst
          }
          beginTime {
            hour
            minute
          }
          endTime {
            hour
            minute
          }
          callWindowQuery {
            field
            operator
            value
          }
          default
          order
        }
        clickToCall
        clickToCallOptions {
          dialMode
          allowManualNumberEntry
          allowMultipleCallsPerContact
        }
        previewDialing
        previewConfig
        callWindows {
          days
          tmz {
            offset
            dst
          }
          beginTime {
            hour
            minute
          }
          endTime {
            hour
            minute
          }
          callWindowQuery {
            field
            operator
            value
          }
          default
          order
        }
        dispositionScoring {
          noAnswer
          answer
          noAgentAvailableToDial
          noAgentOnAnswer
          overApproving
        }
        overrideDispositionScoring
        overrideDialToAgentRatio
        dialToAgentRatio
        freshLIFO
        retryLIFO
        thresholdDialing
        threshold
        thresholdMinimum
        thresholdBatchSize
        updatedBy
        createdAt
        updatedAt
      }
      status
      expireDate
      stopOnCompletion
      cci
      autoMode
      cciMetaData
      callerIdConfigurationId
      callbackConfigurationId
      updatedBy
      createdAt
      updatedAt
    }
  }
`;
export const onCreateProfile = /* GraphQL */ `
  subscription OnCreateProfile($filter: ModelSubscriptionProfileFilterInput) {
    onCreateProfile(filter: $filter) {
      id
      tenant
      name
      useAi
      flowRatio
      scrubber {
        cell
        natDnc
        stateDnc
        orgDnc
        phoneDup
        contactDup
      }
      retry {
        minDuration
        maxAttempts
        maxContacts
        custRetry
        ratio
      }
      ai {
        org
        system
      }
      pushContacts
      startTime
      endTime
      buffer
      channels {
        type
        order
        retryDelay
        maxAttempts
        maxContacts
        custRetry
        paymentProfileId
        paymentProfileName
        dispositions
        cadence
        dialingScript
      }
      ratio
      dontCallOnWeekends
      callWindow {
        days
        tmz {
          offset
          dst
        }
        beginTime {
          hour
          minute
        }
        endTime {
          hour
          minute
        }
        callWindowQuery {
          field
          operator
          value
        }
        default
        order
      }
      clickToCall
      clickToCallOptions {
        dialMode
        allowManualNumberEntry
        allowMultipleCallsPerContact
      }
      previewDialing
      previewConfig
      callWindows {
        days
        tmz {
          offset
          dst
        }
        beginTime {
          hour
          minute
        }
        endTime {
          hour
          minute
        }
        callWindowQuery {
          field
          operator
          value
        }
        default
        order
      }
      dispositionScoring {
        noAnswer
        answer
        noAgentAvailableToDial
        noAgentOnAnswer
        overApproving
      }
      overrideDispositionScoring
      overrideDialToAgentRatio
      dialToAgentRatio
      freshLIFO
      retryLIFO
      thresholdDialing
      threshold
      thresholdMinimum
      thresholdBatchSize
      updatedBy
      createdAt
      updatedAt
    }
  }
`;
export const onUpdateProfile = /* GraphQL */ `
  subscription OnUpdateProfile($filter: ModelSubscriptionProfileFilterInput) {
    onUpdateProfile(filter: $filter) {
      id
      tenant
      name
      useAi
      flowRatio
      scrubber {
        cell
        natDnc
        stateDnc
        orgDnc
        phoneDup
        contactDup
      }
      retry {
        minDuration
        maxAttempts
        maxContacts
        custRetry
        ratio
      }
      ai {
        org
        system
      }
      pushContacts
      startTime
      endTime
      buffer
      channels {
        type
        order
        retryDelay
        maxAttempts
        maxContacts
        custRetry
        paymentProfileId
        paymentProfileName
        dispositions
        cadence
        dialingScript
      }
      ratio
      dontCallOnWeekends
      callWindow {
        days
        tmz {
          offset
          dst
        }
        beginTime {
          hour
          minute
        }
        endTime {
          hour
          minute
        }
        callWindowQuery {
          field
          operator
          value
        }
        default
        order
      }
      clickToCall
      clickToCallOptions {
        dialMode
        allowManualNumberEntry
        allowMultipleCallsPerContact
      }
      previewDialing
      previewConfig
      callWindows {
        days
        tmz {
          offset
          dst
        }
        beginTime {
          hour
          minute
        }
        endTime {
          hour
          minute
        }
        callWindowQuery {
          field
          operator
          value
        }
        default
        order
      }
      dispositionScoring {
        noAnswer
        answer
        noAgentAvailableToDial
        noAgentOnAnswer
        overApproving
      }
      overrideDispositionScoring
      overrideDialToAgentRatio
      dialToAgentRatio
      freshLIFO
      retryLIFO
      thresholdDialing
      threshold
      thresholdMinimum
      thresholdBatchSize
      updatedBy
      createdAt
      updatedAt
    }
  }
`;
export const onDeleteProfile = /* GraphQL */ `
  subscription OnDeleteProfile($filter: ModelSubscriptionProfileFilterInput) {
    onDeleteProfile(filter: $filter) {
      id
      tenant
      name
      useAi
      flowRatio
      scrubber {
        cell
        natDnc
        stateDnc
        orgDnc
        phoneDup
        contactDup
      }
      retry {
        minDuration
        maxAttempts
        maxContacts
        custRetry
        ratio
      }
      ai {
        org
        system
      }
      pushContacts
      startTime
      endTime
      buffer
      channels {
        type
        order
        retryDelay
        maxAttempts
        maxContacts
        custRetry
        paymentProfileId
        paymentProfileName
        dispositions
        cadence
        dialingScript
      }
      ratio
      dontCallOnWeekends
      callWindow {
        days
        tmz {
          offset
          dst
        }
        beginTime {
          hour
          minute
        }
        endTime {
          hour
          minute
        }
        callWindowQuery {
          field
          operator
          value
        }
        default
        order
      }
      clickToCall
      clickToCallOptions {
        dialMode
        allowManualNumberEntry
        allowMultipleCallsPerContact
      }
      previewDialing
      previewConfig
      callWindows {
        days
        tmz {
          offset
          dst
        }
        beginTime {
          hour
          minute
        }
        endTime {
          hour
          minute
        }
        callWindowQuery {
          field
          operator
          value
        }
        default
        order
      }
      dispositionScoring {
        noAnswer
        answer
        noAgentAvailableToDial
        noAgentOnAnswer
        overApproving
      }
      overrideDispositionScoring
      overrideDialToAgentRatio
      dialToAgentRatio
      freshLIFO
      retryLIFO
      thresholdDialing
      threshold
      thresholdMinimum
      thresholdBatchSize
      updatedBy
      createdAt
      updatedAt
    }
  }
`;
export const onCreateManualProfile = /* GraphQL */ `
  subscription OnCreateManualProfile(
    $filter: ModelSubscriptionManualProfileFilterInput
  ) {
    onCreateManualProfile(filter: $filter) {
      id
      tenant
      name
      dialingProfile
      suppressionProfile
      callerIdConfigurationId
      segment
      skills
      manualStrategy
      updatedBy
      createdAt
      updatedAt
    }
  }
`;
export const onUpdateManualProfile = /* GraphQL */ `
  subscription OnUpdateManualProfile(
    $filter: ModelSubscriptionManualProfileFilterInput
  ) {
    onUpdateManualProfile(filter: $filter) {
      id
      tenant
      name
      dialingProfile
      suppressionProfile
      callerIdConfigurationId
      segment
      skills
      manualStrategy
      updatedBy
      createdAt
      updatedAt
    }
  }
`;
export const onDeleteManualProfile = /* GraphQL */ `
  subscription OnDeleteManualProfile(
    $filter: ModelSubscriptionManualProfileFilterInput
  ) {
    onDeleteManualProfile(filter: $filter) {
      id
      tenant
      name
      dialingProfile
      suppressionProfile
      callerIdConfigurationId
      segment
      skills
      manualStrategy
      updatedBy
      createdAt
      updatedAt
    }
  }
`;
export const onCreateSegment = /* GraphQL */ `
  subscription OnCreateSegment($filter: ModelSubscriptionSegmentFilterInput) {
    onCreateSegment(filter: $filter) {
      id
      tenant
      externalId
      name
      description
      query {
        qbQuery
        searchFilter
        sort {
          field
          direction
        }
      }
      filter {
        qbQuery
        searchFilter
        sort {
          field
          direction
        }
      }
      fieldsMappingId
      suppressionID
      suppression {
        id
        tenant
        name
        checks {
          activityLogQuerySuppression {
            query
            rawQuery
            threshold
            result
          }
          pocQuerySuppression {
            query
            rawQuery
            suppressIfWeekendAndCantCallOnWeekends
            result
          }
          restSuppression {
            endpoint
            method
            params {
              key
              value
              description
            }
            headers {
              key
              value
              description
            }
            auth {
              type
              info
            }
            response {
              path
              type
              value
              options
            }
            suppressOnError
            dispositionOnError
            result
          }
          dncDotComSuppression {
            scrub
            state
            numberReassignment
            knownLitigator
            reassignmentSince
            checkOnlyFresh
            result
          }
          dncListSuppressions {
            dncs
            result
          }
          contactFieldSuppressions {
            contactFieldSuppressions
            result
          }
        }
        updatedBy
        createdAt
        updatedAt
      }
      updatedBy
      createdAt
      updatedAt
    }
  }
`;
export const onUpdateSegment = /* GraphQL */ `
  subscription OnUpdateSegment($filter: ModelSubscriptionSegmentFilterInput) {
    onUpdateSegment(filter: $filter) {
      id
      tenant
      externalId
      name
      description
      query {
        qbQuery
        searchFilter
        sort {
          field
          direction
        }
      }
      filter {
        qbQuery
        searchFilter
        sort {
          field
          direction
        }
      }
      fieldsMappingId
      suppressionID
      suppression {
        id
        tenant
        name
        checks {
          activityLogQuerySuppression {
            query
            rawQuery
            threshold
            result
          }
          pocQuerySuppression {
            query
            rawQuery
            suppressIfWeekendAndCantCallOnWeekends
            result
          }
          restSuppression {
            endpoint
            method
            params {
              key
              value
              description
            }
            headers {
              key
              value
              description
            }
            auth {
              type
              info
            }
            response {
              path
              type
              value
              options
            }
            suppressOnError
            dispositionOnError
            result
          }
          dncDotComSuppression {
            scrub
            state
            numberReassignment
            knownLitigator
            reassignmentSince
            checkOnlyFresh
            result
          }
          dncListSuppressions {
            dncs
            result
          }
          contactFieldSuppressions {
            contactFieldSuppressions
            result
          }
        }
        updatedBy
        createdAt
        updatedAt
      }
      updatedBy
      createdAt
      updatedAt
    }
  }
`;
export const onDeleteSegment = /* GraphQL */ `
  subscription OnDeleteSegment($filter: ModelSubscriptionSegmentFilterInput) {
    onDeleteSegment(filter: $filter) {
      id
      tenant
      externalId
      name
      description
      query {
        qbQuery
        searchFilter
        sort {
          field
          direction
        }
      }
      filter {
        qbQuery
        searchFilter
        sort {
          field
          direction
        }
      }
      fieldsMappingId
      suppressionID
      suppression {
        id
        tenant
        name
        checks {
          activityLogQuerySuppression {
            query
            rawQuery
            threshold
            result
          }
          pocQuerySuppression {
            query
            rawQuery
            suppressIfWeekendAndCantCallOnWeekends
            result
          }
          restSuppression {
            endpoint
            method
            params {
              key
              value
              description
            }
            headers {
              key
              value
              description
            }
            auth {
              type
              info
            }
            response {
              path
              type
              value
              options
            }
            suppressOnError
            dispositionOnError
            result
          }
          dncDotComSuppression {
            scrub
            state
            numberReassignment
            knownLitigator
            reassignmentSince
            checkOnlyFresh
            result
          }
          dncListSuppressions {
            dncs
            result
          }
          contactFieldSuppressions {
            contactFieldSuppressions
            result
          }
        }
        updatedBy
        createdAt
        updatedAt
      }
      updatedBy
      createdAt
      updatedAt
    }
  }
`;
export const onCreateActivityLog = /* GraphQL */ `
  subscription OnCreateActivityLog(
    $filter: ModelSubscriptionActivityLogFilterInput
  ) {
    onCreateActivityLog(filter: $filter) {
      id
      tenant
      type
      disposition
      title
      body
      activityLogContactId
      contact {
        id
        tenant
        externalId
        firstName
        lastName
        source
        phone
        cell
        email
        dateCreated
        address1
        address2
        city
        state
        zip
        country
        dnc
        updatedBy
        customFields
        expireDt
        outboundCallerId
        assignedAgent
        balances {
          id
          type
          amount
          age
        }
        timeZone
        timeZoneBounds {
          min {
            offset
            dst
          }
          max {
            offset
            dst
          }
        }
        type
        optOuts {
          voice
          sms
          email
        }
        optIns {
          voice
          sms
          email
        }
        attempts
        createdAt
        updatedAt
      }
      segment {
        id
        tenant
        externalId
        name
        description
        query {
          qbQuery
          searchFilter
          sort {
            field
            direction
          }
        }
        filter {
          qbQuery
          searchFilter
          sort {
            field
            direction
          }
        }
        fieldsMappingId
        suppressionID
        suppression {
          id
          tenant
          name
          checks {
            activityLogQuerySuppression {
              query
              rawQuery
              threshold
              result
            }
            pocQuerySuppression {
              query
              rawQuery
              suppressIfWeekendAndCantCallOnWeekends
              result
            }
            restSuppression {
              endpoint
              method
              params {
                key
                value
                description
              }
              headers {
                key
                value
                description
              }
              auth {
                type
                info
              }
              response {
                path
                type
                value
                options
              }
              suppressOnError
              dispositionOnError
              result
            }
            dncDotComSuppression {
              scrub
              state
              numberReassignment
              knownLitigator
              reassignmentSince
              checkOnlyFresh
              result
            }
            dncListSuppressions {
              dncs
              result
            }
            contactFieldSuppressions {
              contactFieldSuppressions
              result
            }
          }
          updatedBy
          createdAt
          updatedAt
        }
        updatedBy
        createdAt
        updatedAt
      }
      campaign {
        id
        tenant
        name
        segments
        segmentSchedule
        campaignSchedule
        reportSchedule
        static
        sort
        skillId
        skillName
        skillSource
        campaignProfileId
        profile {
          id
          tenant
          name
          useAi
          flowRatio
          scrubber {
            cell
            natDnc
            stateDnc
            orgDnc
            phoneDup
            contactDup
          }
          retry {
            minDuration
            maxAttempts
            maxContacts
            custRetry
            ratio
          }
          ai {
            org
            system
          }
          pushContacts
          startTime
          endTime
          buffer
          channels {
            type
            order
            retryDelay
            maxAttempts
            maxContacts
            custRetry
            paymentProfileId
            paymentProfileName
            dispositions
            cadence
            dialingScript
          }
          ratio
          dontCallOnWeekends
          callWindow {
            days
            tmz {
              offset
              dst
            }
            beginTime {
              hour
              minute
            }
            endTime {
              hour
              minute
            }
            callWindowQuery {
              field
              operator
              value
            }
            default
            order
          }
          clickToCall
          clickToCallOptions {
            dialMode
            allowManualNumberEntry
            allowMultipleCallsPerContact
          }
          previewDialing
          previewConfig
          callWindows {
            days
            tmz {
              offset
              dst
            }
            beginTime {
              hour
              minute
            }
            endTime {
              hour
              minute
            }
            callWindowQuery {
              field
              operator
              value
            }
            default
            order
          }
          dispositionScoring {
            noAnswer
            answer
            noAgentAvailableToDial
            noAgentOnAnswer
            overApproving
          }
          overrideDispositionScoring
          overrideDialToAgentRatio
          dialToAgentRatio
          freshLIFO
          retryLIFO
          thresholdDialing
          threshold
          thresholdMinimum
          thresholdBatchSize
          updatedBy
          createdAt
          updatedAt
        }
        status
        expireDate
        stopOnCompletion
        cci
        autoMode
        cciMetaData
        callerIdConfigurationId
        callbackConfigurationId
        updatedBy
        createdAt
        updatedAt
      }
      agent
      contactStatus
      timestamp
      metaData
      provider
      c2aId
      pocActual
      outboundCallerId
      callDurationSeconds
      ttl
      createdAt
      updatedAt
      activityLogSegmentId
      activityLogCampaignId
    }
  }
`;
export const onUpdateActivityLog = /* GraphQL */ `
  subscription OnUpdateActivityLog(
    $filter: ModelSubscriptionActivityLogFilterInput
  ) {
    onUpdateActivityLog(filter: $filter) {
      id
      tenant
      type
      disposition
      title
      body
      activityLogContactId
      contact {
        id
        tenant
        externalId
        firstName
        lastName
        source
        phone
        cell
        email
        dateCreated
        address1
        address2
        city
        state
        zip
        country
        dnc
        updatedBy
        customFields
        expireDt
        outboundCallerId
        assignedAgent
        balances {
          id
          type
          amount
          age
        }
        timeZone
        timeZoneBounds {
          min {
            offset
            dst
          }
          max {
            offset
            dst
          }
        }
        type
        optOuts {
          voice
          sms
          email
        }
        optIns {
          voice
          sms
          email
        }
        attempts
        createdAt
        updatedAt
      }
      segment {
        id
        tenant
        externalId
        name
        description
        query {
          qbQuery
          searchFilter
          sort {
            field
            direction
          }
        }
        filter {
          qbQuery
          searchFilter
          sort {
            field
            direction
          }
        }
        fieldsMappingId
        suppressionID
        suppression {
          id
          tenant
          name
          checks {
            activityLogQuerySuppression {
              query
              rawQuery
              threshold
              result
            }
            pocQuerySuppression {
              query
              rawQuery
              suppressIfWeekendAndCantCallOnWeekends
              result
            }
            restSuppression {
              endpoint
              method
              params {
                key
                value
                description
              }
              headers {
                key
                value
                description
              }
              auth {
                type
                info
              }
              response {
                path
                type
                value
                options
              }
              suppressOnError
              dispositionOnError
              result
            }
            dncDotComSuppression {
              scrub
              state
              numberReassignment
              knownLitigator
              reassignmentSince
              checkOnlyFresh
              result
            }
            dncListSuppressions {
              dncs
              result
            }
            contactFieldSuppressions {
              contactFieldSuppressions
              result
            }
          }
          updatedBy
          createdAt
          updatedAt
        }
        updatedBy
        createdAt
        updatedAt
      }
      campaign {
        id
        tenant
        name
        segments
        segmentSchedule
        campaignSchedule
        reportSchedule
        static
        sort
        skillId
        skillName
        skillSource
        campaignProfileId
        profile {
          id
          tenant
          name
          useAi
          flowRatio
          scrubber {
            cell
            natDnc
            stateDnc
            orgDnc
            phoneDup
            contactDup
          }
          retry {
            minDuration
            maxAttempts
            maxContacts
            custRetry
            ratio
          }
          ai {
            org
            system
          }
          pushContacts
          startTime
          endTime
          buffer
          channels {
            type
            order
            retryDelay
            maxAttempts
            maxContacts
            custRetry
            paymentProfileId
            paymentProfileName
            dispositions
            cadence
            dialingScript
          }
          ratio
          dontCallOnWeekends
          callWindow {
            days
            tmz {
              offset
              dst
            }
            beginTime {
              hour
              minute
            }
            endTime {
              hour
              minute
            }
            callWindowQuery {
              field
              operator
              value
            }
            default
            order
          }
          clickToCall
          clickToCallOptions {
            dialMode
            allowManualNumberEntry
            allowMultipleCallsPerContact
          }
          previewDialing
          previewConfig
          callWindows {
            days
            tmz {
              offset
              dst
            }
            beginTime {
              hour
              minute
            }
            endTime {
              hour
              minute
            }
            callWindowQuery {
              field
              operator
              value
            }
            default
            order
          }
          dispositionScoring {
            noAnswer
            answer
            noAgentAvailableToDial
            noAgentOnAnswer
            overApproving
          }
          overrideDispositionScoring
          overrideDialToAgentRatio
          dialToAgentRatio
          freshLIFO
          retryLIFO
          thresholdDialing
          threshold
          thresholdMinimum
          thresholdBatchSize
          updatedBy
          createdAt
          updatedAt
        }
        status
        expireDate
        stopOnCompletion
        cci
        autoMode
        cciMetaData
        callerIdConfigurationId
        callbackConfigurationId
        updatedBy
        createdAt
        updatedAt
      }
      agent
      contactStatus
      timestamp
      metaData
      provider
      c2aId
      pocActual
      outboundCallerId
      callDurationSeconds
      ttl
      createdAt
      updatedAt
      activityLogSegmentId
      activityLogCampaignId
    }
  }
`;
export const onDeleteActivityLog = /* GraphQL */ `
  subscription OnDeleteActivityLog(
    $filter: ModelSubscriptionActivityLogFilterInput
  ) {
    onDeleteActivityLog(filter: $filter) {
      id
      tenant
      type
      disposition
      title
      body
      activityLogContactId
      contact {
        id
        tenant
        externalId
        firstName
        lastName
        source
        phone
        cell
        email
        dateCreated
        address1
        address2
        city
        state
        zip
        country
        dnc
        updatedBy
        customFields
        expireDt
        outboundCallerId
        assignedAgent
        balances {
          id
          type
          amount
          age
        }
        timeZone
        timeZoneBounds {
          min {
            offset
            dst
          }
          max {
            offset
            dst
          }
        }
        type
        optOuts {
          voice
          sms
          email
        }
        optIns {
          voice
          sms
          email
        }
        attempts
        createdAt
        updatedAt
      }
      segment {
        id
        tenant
        externalId
        name
        description
        query {
          qbQuery
          searchFilter
          sort {
            field
            direction
          }
        }
        filter {
          qbQuery
          searchFilter
          sort {
            field
            direction
          }
        }
        fieldsMappingId
        suppressionID
        suppression {
          id
          tenant
          name
          checks {
            activityLogQuerySuppression {
              query
              rawQuery
              threshold
              result
            }
            pocQuerySuppression {
              query
              rawQuery
              suppressIfWeekendAndCantCallOnWeekends
              result
            }
            restSuppression {
              endpoint
              method
              params {
                key
                value
                description
              }
              headers {
                key
                value
                description
              }
              auth {
                type
                info
              }
              response {
                path
                type
                value
                options
              }
              suppressOnError
              dispositionOnError
              result
            }
            dncDotComSuppression {
              scrub
              state
              numberReassignment
              knownLitigator
              reassignmentSince
              checkOnlyFresh
              result
            }
            dncListSuppressions {
              dncs
              result
            }
            contactFieldSuppressions {
              contactFieldSuppressions
              result
            }
          }
          updatedBy
          createdAt
          updatedAt
        }
        updatedBy
        createdAt
        updatedAt
      }
      campaign {
        id
        tenant
        name
        segments
        segmentSchedule
        campaignSchedule
        reportSchedule
        static
        sort
        skillId
        skillName
        skillSource
        campaignProfileId
        profile {
          id
          tenant
          name
          useAi
          flowRatio
          scrubber {
            cell
            natDnc
            stateDnc
            orgDnc
            phoneDup
            contactDup
          }
          retry {
            minDuration
            maxAttempts
            maxContacts
            custRetry
            ratio
          }
          ai {
            org
            system
          }
          pushContacts
          startTime
          endTime
          buffer
          channels {
            type
            order
            retryDelay
            maxAttempts
            maxContacts
            custRetry
            paymentProfileId
            paymentProfileName
            dispositions
            cadence
            dialingScript
          }
          ratio
          dontCallOnWeekends
          callWindow {
            days
            tmz {
              offset
              dst
            }
            beginTime {
              hour
              minute
            }
            endTime {
              hour
              minute
            }
            callWindowQuery {
              field
              operator
              value
            }
            default
            order
          }
          clickToCall
          clickToCallOptions {
            dialMode
            allowManualNumberEntry
            allowMultipleCallsPerContact
          }
          previewDialing
          previewConfig
          callWindows {
            days
            tmz {
              offset
              dst
            }
            beginTime {
              hour
              minute
            }
            endTime {
              hour
              minute
            }
            callWindowQuery {
              field
              operator
              value
            }
            default
            order
          }
          dispositionScoring {
            noAnswer
            answer
            noAgentAvailableToDial
            noAgentOnAnswer
            overApproving
          }
          overrideDispositionScoring
          overrideDialToAgentRatio
          dialToAgentRatio
          freshLIFO
          retryLIFO
          thresholdDialing
          threshold
          thresholdMinimum
          thresholdBatchSize
          updatedBy
          createdAt
          updatedAt
        }
        status
        expireDate
        stopOnCompletion
        cci
        autoMode
        cciMetaData
        callerIdConfigurationId
        callbackConfigurationId
        updatedBy
        createdAt
        updatedAt
      }
      agent
      contactStatus
      timestamp
      metaData
      provider
      c2aId
      pocActual
      outboundCallerId
      callDurationSeconds
      ttl
      createdAt
      updatedAt
      activityLogSegmentId
      activityLogCampaignId
    }
  }
`;
export const onCreateCampaignLog = /* GraphQL */ `
  subscription OnCreateCampaignLog(
    $filter: ModelSubscriptionCampaignLogFilterInput
  ) {
    onCreateCampaignLog(filter: $filter) {
      id
      tenant
      campaign
      type
      metaData
      createdAt
      updatedAt
    }
  }
`;
export const onUpdateCampaignLog = /* GraphQL */ `
  subscription OnUpdateCampaignLog(
    $filter: ModelSubscriptionCampaignLogFilterInput
  ) {
    onUpdateCampaignLog(filter: $filter) {
      id
      tenant
      campaign
      type
      metaData
      createdAt
      updatedAt
    }
  }
`;
export const onDeleteCampaignLog = /* GraphQL */ `
  subscription OnDeleteCampaignLog(
    $filter: ModelSubscriptionCampaignLogFilterInput
  ) {
    onDeleteCampaignLog(filter: $filter) {
      id
      tenant
      campaign
      type
      metaData
      createdAt
      updatedAt
    }
  }
`;
export const onCreateAuditLog = /* GraphQL */ `
  subscription OnCreateAuditLog($filter: ModelSubscriptionAuditLogFilterInput) {
    onCreateAuditLog(filter: $filter) {
      id
      tenant
      type
      timestamp
      userName
      documentId
      name
      currentValue
      action
      ttl
      createdAt
      updatedAt
    }
  }
`;
export const onUpdateAuditLog = /* GraphQL */ `
  subscription OnUpdateAuditLog($filter: ModelSubscriptionAuditLogFilterInput) {
    onUpdateAuditLog(filter: $filter) {
      id
      tenant
      type
      timestamp
      userName
      documentId
      name
      currentValue
      action
      ttl
      createdAt
      updatedAt
    }
  }
`;
export const onDeleteAuditLog = /* GraphQL */ `
  subscription OnDeleteAuditLog($filter: ModelSubscriptionAuditLogFilterInput) {
    onDeleteAuditLog(filter: $filter) {
      id
      tenant
      type
      timestamp
      userName
      documentId
      name
      currentValue
      action
      ttl
      createdAt
      updatedAt
    }
  }
`;
export const onCreateConfigProfile = /* GraphQL */ `
  subscription OnCreateConfigProfile(
    $filter: ModelSubscriptionConfigProfileFilterInput
  ) {
    onCreateConfigProfile(filter: $filter) {
      id
      tenant
      name
      direction
      mediaType
      crmEntity
      org {
        name
        id
        url
        version
      }
      connection {
        dynamicsTenant
        appSecret
        clientId
        altUrl
        authUrl
        onPremVersion
      }
      skillIds
      multiSearch
      search
      searchAction
      activityEntityMap
      logging
      postLogging
      loggingAction
      createdAt
      updatedAt
    }
  }
`;
export const onUpdateConfigProfile = /* GraphQL */ `
  subscription OnUpdateConfigProfile(
    $filter: ModelSubscriptionConfigProfileFilterInput
  ) {
    onUpdateConfigProfile(filter: $filter) {
      id
      tenant
      name
      direction
      mediaType
      crmEntity
      org {
        name
        id
        url
        version
      }
      connection {
        dynamicsTenant
        appSecret
        clientId
        altUrl
        authUrl
        onPremVersion
      }
      skillIds
      multiSearch
      search
      searchAction
      activityEntityMap
      logging
      postLogging
      loggingAction
      createdAt
      updatedAt
    }
  }
`;
export const onDeleteConfigProfile = /* GraphQL */ `
  subscription OnDeleteConfigProfile(
    $filter: ModelSubscriptionConfigProfileFilterInput
  ) {
    onDeleteConfigProfile(filter: $filter) {
      id
      tenant
      name
      direction
      mediaType
      crmEntity
      org {
        name
        id
        url
        version
      }
      connection {
        dynamicsTenant
        appSecret
        clientId
        altUrl
        authUrl
        onPremVersion
      }
      skillIds
      multiSearch
      search
      searchAction
      activityEntityMap
      logging
      postLogging
      loggingAction
      createdAt
      updatedAt
    }
  }
`;
export const onCreateCallerId = /* GraphQL */ `
  subscription OnCreateCallerId($filter: ModelSubscriptionCallerIdFilterInput) {
    onCreateCallerId(filter: $filter) {
      id
      tenant
      name
      number
      carrier
      createdAt
      updatedAt
    }
  }
`;
export const onUpdateCallerId = /* GraphQL */ `
  subscription OnUpdateCallerId($filter: ModelSubscriptionCallerIdFilterInput) {
    onUpdateCallerId(filter: $filter) {
      id
      tenant
      name
      number
      carrier
      createdAt
      updatedAt
    }
  }
`;
export const onDeleteCallerId = /* GraphQL */ `
  subscription OnDeleteCallerId($filter: ModelSubscriptionCallerIdFilterInput) {
    onDeleteCallerId(filter: $filter) {
      id
      tenant
      name
      number
      carrier
      createdAt
      updatedAt
    }
  }
`;
export const onCreateCallerIdConfiguration = /* GraphQL */ `
  subscription OnCreateCallerIdConfiguration(
    $filter: ModelSubscriptionCallerIdConfigurationFilterInput
  ) {
    onCreateCallerIdConfiguration(filter: $filter) {
      id
      tenant
      name
      configs {
        type
        query
        pool
      }
      createdAt
      updatedAt
    }
  }
`;
export const onUpdateCallerIdConfiguration = /* GraphQL */ `
  subscription OnUpdateCallerIdConfiguration(
    $filter: ModelSubscriptionCallerIdConfigurationFilterInput
  ) {
    onUpdateCallerIdConfiguration(filter: $filter) {
      id
      tenant
      name
      configs {
        type
        query
        pool
      }
      createdAt
      updatedAt
    }
  }
`;
export const onDeleteCallerIdConfiguration = /* GraphQL */ `
  subscription OnDeleteCallerIdConfiguration(
    $filter: ModelSubscriptionCallerIdConfigurationFilterInput
  ) {
    onDeleteCallerIdConfiguration(filter: $filter) {
      id
      tenant
      name
      configs {
        type
        query
        pool
      }
      createdAt
      updatedAt
    }
  }
`;
export const onCreateCurfewXCodes = /* GraphQL */ `
  subscription OnCreateCurfewXCodes(
    $filter: ModelSubscriptionCurfewXCodesFilterInput
  ) {
    onCreateCurfewXCodes(filter: $filter) {
      id
      minOffSet
      maxOffSet
      dls
      createdAt
      updatedAt
    }
  }
`;
export const onUpdateCurfewXCodes = /* GraphQL */ `
  subscription OnUpdateCurfewXCodes(
    $filter: ModelSubscriptionCurfewXCodesFilterInput
  ) {
    onUpdateCurfewXCodes(filter: $filter) {
      id
      minOffSet
      maxOffSet
      dls
      createdAt
      updatedAt
    }
  }
`;
export const onDeleteCurfewXCodes = /* GraphQL */ `
  subscription OnDeleteCurfewXCodes(
    $filter: ModelSubscriptionCurfewXCodesFilterInput
  ) {
    onDeleteCurfewXCodes(filter: $filter) {
      id
      minOffSet
      maxOffSet
      dls
      createdAt
      updatedAt
    }
  }
`;
export const onCreateNotification = /* GraphQL */ `
  subscription OnCreateNotification(
    $filter: ModelSubscriptionNotificationFilterInput
  ) {
    onCreateNotification(filter: $filter) {
      id
      tenant
      cognitoId
      subject
      body
      link
      read
      ttl
      createdAt
      updatedAt
    }
  }
`;
export const onUpdateNotification = /* GraphQL */ `
  subscription OnUpdateNotification(
    $filter: ModelSubscriptionNotificationFilterInput
  ) {
    onUpdateNotification(filter: $filter) {
      id
      tenant
      cognitoId
      subject
      body
      link
      read
      ttl
      createdAt
      updatedAt
    }
  }
`;
export const onDeleteNotification = /* GraphQL */ `
  subscription OnDeleteNotification(
    $filter: ModelSubscriptionNotificationFilterInput
  ) {
    onDeleteNotification(filter: $filter) {
      id
      tenant
      cognitoId
      subject
      body
      link
      read
      ttl
      createdAt
      updatedAt
    }
  }
`;
export const onCreateNotificationGroup = /* GraphQL */ `
  subscription OnCreateNotificationGroup(
    $filter: ModelSubscriptionNotificationGroupFilterInput
  ) {
    onCreateNotificationGroup(filter: $filter) {
      id
      tenant
      name
      members {
        cognitoId
        name
        email
      }
      createdAt
      updatedAt
    }
  }
`;
export const onUpdateNotificationGroup = /* GraphQL */ `
  subscription OnUpdateNotificationGroup(
    $filter: ModelSubscriptionNotificationGroupFilterInput
  ) {
    onUpdateNotificationGroup(filter: $filter) {
      id
      tenant
      name
      members {
        cognitoId
        name
        email
      }
      createdAt
      updatedAt
    }
  }
`;
export const onDeleteNotificationGroup = /* GraphQL */ `
  subscription OnDeleteNotificationGroup(
    $filter: ModelSubscriptionNotificationGroupFilterInput
  ) {
    onDeleteNotificationGroup(filter: $filter) {
      id
      tenant
      name
      members {
        cognitoId
        name
        email
      }
      createdAt
      updatedAt
    }
  }
`;
export const onCreatePaymentProfile = /* GraphQL */ `
  subscription OnCreatePaymentProfile(
    $filter: ModelSubscriptionPaymentProfileFilterInput
  ) {
    onCreatePaymentProfile(filter: $filter) {
      id
      tenant
      name
      vendorId
      apiKey
      descriptor
      ttl
      siteLogo
      header1
      header2
      sitePrimary
      siteSecondary
      minType
      minRate
      supportEmail
      supportPhone
      promptPaySkills
      channels
      c2a
      subject
      sendingEmail
      createdAt
      updatedAt
    }
  }
`;
export const onUpdatePaymentProfile = /* GraphQL */ `
  subscription OnUpdatePaymentProfile(
    $filter: ModelSubscriptionPaymentProfileFilterInput
  ) {
    onUpdatePaymentProfile(filter: $filter) {
      id
      tenant
      name
      vendorId
      apiKey
      descriptor
      ttl
      siteLogo
      header1
      header2
      sitePrimary
      siteSecondary
      minType
      minRate
      supportEmail
      supportPhone
      promptPaySkills
      channels
      c2a
      subject
      sendingEmail
      createdAt
      updatedAt
    }
  }
`;
export const onDeletePaymentProfile = /* GraphQL */ `
  subscription OnDeletePaymentProfile(
    $filter: ModelSubscriptionPaymentProfileFilterInput
  ) {
    onDeletePaymentProfile(filter: $filter) {
      id
      tenant
      name
      vendorId
      apiKey
      descriptor
      ttl
      siteLogo
      header1
      header2
      sitePrimary
      siteSecondary
      minType
      minRate
      supportEmail
      supportPhone
      promptPaySkills
      channels
      c2a
      subject
      sendingEmail
      createdAt
      updatedAt
    }
  }
`;
export const onCreatePaymentTemplate = /* GraphQL */ `
  subscription OnCreatePaymentTemplate(
    $filter: ModelSubscriptionPaymentTemplateFilterInput
  ) {
    onCreatePaymentTemplate(filter: $filter) {
      id
      tenant
      name
      textBody
      type
      createdAt
      updatedAt
    }
  }
`;
export const onUpdatePaymentTemplate = /* GraphQL */ `
  subscription OnUpdatePaymentTemplate(
    $filter: ModelSubscriptionPaymentTemplateFilterInput
  ) {
    onUpdatePaymentTemplate(filter: $filter) {
      id
      tenant
      name
      textBody
      type
      createdAt
      updatedAt
    }
  }
`;
export const onDeletePaymentTemplate = /* GraphQL */ `
  subscription OnDeletePaymentTemplate(
    $filter: ModelSubscriptionPaymentTemplateFilterInput
  ) {
    onDeletePaymentTemplate(filter: $filter) {
      id
      tenant
      name
      textBody
      type
      createdAt
      updatedAt
    }
  }
`;
export const onCreateCustomDispoMapping = /* GraphQL */ `
  subscription OnCreateCustomDispoMapping(
    $filter: ModelSubscriptionCustomDispoMappingFilterInput
  ) {
    onCreateCustomDispoMapping(filter: $filter) {
      id
      tenant
      skill
      custDispId
      custDispName
      dispClassId
      dispCode
      dispDescription
      dispClassName
      createdAt
      updatedAt
    }
  }
`;
export const onUpdateCustomDispoMapping = /* GraphQL */ `
  subscription OnUpdateCustomDispoMapping(
    $filter: ModelSubscriptionCustomDispoMappingFilterInput
  ) {
    onUpdateCustomDispoMapping(filter: $filter) {
      id
      tenant
      skill
      custDispId
      custDispName
      dispClassId
      dispCode
      dispDescription
      dispClassName
      createdAt
      updatedAt
    }
  }
`;
export const onDeleteCustomDispoMapping = /* GraphQL */ `
  subscription OnDeleteCustomDispoMapping(
    $filter: ModelSubscriptionCustomDispoMappingFilterInput
  ) {
    onDeleteCustomDispoMapping(filter: $filter) {
      id
      tenant
      skill
      custDispId
      custDispName
      dispClassId
      dispCode
      dispDescription
      dispClassName
      createdAt
      updatedAt
    }
  }
`;
export const onCreateCustomDispositions = /* GraphQL */ `
  subscription OnCreateCustomDispositions(
    $filter: ModelSubscriptionCustomDispositionsFilterInput
  ) {
    onCreateCustomDispositions(filter: $filter) {
      id
      tenant
      name
      description
      classification
      previewDispo
      noteRequired
      amountRequired
      rescheduleDateRequired
      createdAt
      updatedAt
    }
  }
`;
export const onUpdateCustomDispositions = /* GraphQL */ `
  subscription OnUpdateCustomDispositions(
    $filter: ModelSubscriptionCustomDispositionsFilterInput
  ) {
    onUpdateCustomDispositions(filter: $filter) {
      id
      tenant
      name
      description
      classification
      previewDispo
      noteRequired
      amountRequired
      rescheduleDateRequired
      createdAt
      updatedAt
    }
  }
`;
export const onDeleteCustomDispositions = /* GraphQL */ `
  subscription OnDeleteCustomDispositions(
    $filter: ModelSubscriptionCustomDispositionsFilterInput
  ) {
    onDeleteCustomDispositions(filter: $filter) {
      id
      tenant
      name
      description
      classification
      previewDispo
      noteRequired
      amountRequired
      rescheduleDateRequired
      createdAt
      updatedAt
    }
  }
`;
export const onCreateAgentScript = /* GraphQL */ `
  subscription OnCreateAgentScript(
    $filter: ModelSubscriptionAgentScriptFilterInput
  ) {
    onCreateAgentScript(filter: $filter) {
      id
      tenant
      name
      level
      type
      children {
        items {
          id
          parentId
          childId
          parent {
            id
            tenant
            name
            level
            type
            children {
              items {
                id
                parentId
                childId
                createdAt
                updatedAt
              }
              nextToken
            }
            textBody
            isRoot
            createdAt
            updatedAt
          }
          child {
            id
            tenant
            name
            level
            type
            children {
              items {
                id
                parentId
                childId
                createdAt
                updatedAt
              }
              nextToken
            }
            textBody
            isRoot
            createdAt
            updatedAt
          }
          createdAt
          updatedAt
        }
        nextToken
      }
      textBody
      isRoot
      createdAt
      updatedAt
    }
  }
`;
export const onUpdateAgentScript = /* GraphQL */ `
  subscription OnUpdateAgentScript(
    $filter: ModelSubscriptionAgentScriptFilterInput
  ) {
    onUpdateAgentScript(filter: $filter) {
      id
      tenant
      name
      level
      type
      children {
        items {
          id
          parentId
          childId
          parent {
            id
            tenant
            name
            level
            type
            children {
              items {
                id
                parentId
                childId
                createdAt
                updatedAt
              }
              nextToken
            }
            textBody
            isRoot
            createdAt
            updatedAt
          }
          child {
            id
            tenant
            name
            level
            type
            children {
              items {
                id
                parentId
                childId
                createdAt
                updatedAt
              }
              nextToken
            }
            textBody
            isRoot
            createdAt
            updatedAt
          }
          createdAt
          updatedAt
        }
        nextToken
      }
      textBody
      isRoot
      createdAt
      updatedAt
    }
  }
`;
export const onDeleteAgentScript = /* GraphQL */ `
  subscription OnDeleteAgentScript(
    $filter: ModelSubscriptionAgentScriptFilterInput
  ) {
    onDeleteAgentScript(filter: $filter) {
      id
      tenant
      name
      level
      type
      children {
        items {
          id
          parentId
          childId
          parent {
            id
            tenant
            name
            level
            type
            children {
              items {
                id
                parentId
                childId
                createdAt
                updatedAt
              }
              nextToken
            }
            textBody
            isRoot
            createdAt
            updatedAt
          }
          child {
            id
            tenant
            name
            level
            type
            children {
              items {
                id
                parentId
                childId
                createdAt
                updatedAt
              }
              nextToken
            }
            textBody
            isRoot
            createdAt
            updatedAt
          }
          createdAt
          updatedAt
        }
        nextToken
      }
      textBody
      isRoot
      createdAt
      updatedAt
    }
  }
`;
export const onCreateAgentScriptConnector = /* GraphQL */ `
  subscription OnCreateAgentScriptConnector(
    $filter: ModelSubscriptionAgentScriptConnectorFilterInput
  ) {
    onCreateAgentScriptConnector(filter: $filter) {
      id
      parentId
      childId
      parent {
        id
        tenant
        name
        level
        type
        children {
          items {
            id
            parentId
            childId
            parent {
              id
              tenant
              name
              level
              type
              children {
                nextToken
              }
              textBody
              isRoot
              createdAt
              updatedAt
            }
            child {
              id
              tenant
              name
              level
              type
              children {
                nextToken
              }
              textBody
              isRoot
              createdAt
              updatedAt
            }
            createdAt
            updatedAt
          }
          nextToken
        }
        textBody
        isRoot
        createdAt
        updatedAt
      }
      child {
        id
        tenant
        name
        level
        type
        children {
          items {
            id
            parentId
            childId
            parent {
              id
              tenant
              name
              level
              type
              children {
                nextToken
              }
              textBody
              isRoot
              createdAt
              updatedAt
            }
            child {
              id
              tenant
              name
              level
              type
              children {
                nextToken
              }
              textBody
              isRoot
              createdAt
              updatedAt
            }
            createdAt
            updatedAt
          }
          nextToken
        }
        textBody
        isRoot
        createdAt
        updatedAt
      }
      createdAt
      updatedAt
    }
  }
`;
export const onUpdateAgentScriptConnector = /* GraphQL */ `
  subscription OnUpdateAgentScriptConnector(
    $filter: ModelSubscriptionAgentScriptConnectorFilterInput
  ) {
    onUpdateAgentScriptConnector(filter: $filter) {
      id
      parentId
      childId
      parent {
        id
        tenant
        name
        level
        type
        children {
          items {
            id
            parentId
            childId
            parent {
              id
              tenant
              name
              level
              type
              children {
                nextToken
              }
              textBody
              isRoot
              createdAt
              updatedAt
            }
            child {
              id
              tenant
              name
              level
              type
              children {
                nextToken
              }
              textBody
              isRoot
              createdAt
              updatedAt
            }
            createdAt
            updatedAt
          }
          nextToken
        }
        textBody
        isRoot
        createdAt
        updatedAt
      }
      child {
        id
        tenant
        name
        level
        type
        children {
          items {
            id
            parentId
            childId
            parent {
              id
              tenant
              name
              level
              type
              children {
                nextToken
              }
              textBody
              isRoot
              createdAt
              updatedAt
            }
            child {
              id
              tenant
              name
              level
              type
              children {
                nextToken
              }
              textBody
              isRoot
              createdAt
              updatedAt
            }
            createdAt
            updatedAt
          }
          nextToken
        }
        textBody
        isRoot
        createdAt
        updatedAt
      }
      createdAt
      updatedAt
    }
  }
`;
export const onDeleteAgentScriptConnector = /* GraphQL */ `
  subscription OnDeleteAgentScriptConnector(
    $filter: ModelSubscriptionAgentScriptConnectorFilterInput
  ) {
    onDeleteAgentScriptConnector(filter: $filter) {
      id
      parentId
      childId
      parent {
        id
        tenant
        name
        level
        type
        children {
          items {
            id
            parentId
            childId
            parent {
              id
              tenant
              name
              level
              type
              children {
                nextToken
              }
              textBody
              isRoot
              createdAt
              updatedAt
            }
            child {
              id
              tenant
              name
              level
              type
              children {
                nextToken
              }
              textBody
              isRoot
              createdAt
              updatedAt
            }
            createdAt
            updatedAt
          }
          nextToken
        }
        textBody
        isRoot
        createdAt
        updatedAt
      }
      child {
        id
        tenant
        name
        level
        type
        children {
          items {
            id
            parentId
            childId
            parent {
              id
              tenant
              name
              level
              type
              children {
                nextToken
              }
              textBody
              isRoot
              createdAt
              updatedAt
            }
            child {
              id
              tenant
              name
              level
              type
              children {
                nextToken
              }
              textBody
              isRoot
              createdAt
              updatedAt
            }
            createdAt
            updatedAt
          }
          nextToken
        }
        textBody
        isRoot
        createdAt
        updatedAt
      }
      createdAt
      updatedAt
    }
  }
`;
export const onCreateCryptoPassport = /* GraphQL */ `
  subscription OnCreateCryptoPassport(
    $filter: ModelSubscriptionCryptoPassportFilterInput
  ) {
    onCreateCryptoPassport(filter: $filter) {
      id
      token
      ttl
      createdAt
      updatedAt
    }
  }
`;
export const onUpdateCryptoPassport = /* GraphQL */ `
  subscription OnUpdateCryptoPassport(
    $filter: ModelSubscriptionCryptoPassportFilterInput
  ) {
    onUpdateCryptoPassport(filter: $filter) {
      id
      token
      ttl
      createdAt
      updatedAt
    }
  }
`;
export const onDeleteCryptoPassport = /* GraphQL */ `
  subscription OnDeleteCryptoPassport(
    $filter: ModelSubscriptionCryptoPassportFilterInput
  ) {
    onDeleteCryptoPassport(filter: $filter) {
      id
      token
      ttl
      createdAt
      updatedAt
    }
  }
`;
export const onCreateDNCList = /* GraphQL */ `
  subscription OnCreateDNCList($filter: ModelSubscriptionDNCListFilterInput) {
    onCreateDNCList(filter: $filter) {
      id
      tenant
      name
      numbers {
        items {
          id
          tenant
          phoneNumber
          dncList
          createdAt
          updatedAt
        }
        nextToken
      }
      createdAt
      updatedAt
    }
  }
`;
export const onUpdateDNCList = /* GraphQL */ `
  subscription OnUpdateDNCList($filter: ModelSubscriptionDNCListFilterInput) {
    onUpdateDNCList(filter: $filter) {
      id
      tenant
      name
      numbers {
        items {
          id
          tenant
          phoneNumber
          dncList
          createdAt
          updatedAt
        }
        nextToken
      }
      createdAt
      updatedAt
    }
  }
`;
export const onDeleteDNCList = /* GraphQL */ `
  subscription OnDeleteDNCList($filter: ModelSubscriptionDNCListFilterInput) {
    onDeleteDNCList(filter: $filter) {
      id
      tenant
      name
      numbers {
        items {
          id
          tenant
          phoneNumber
          dncList
          createdAt
          updatedAt
        }
        nextToken
      }
      createdAt
      updatedAt
    }
  }
`;
export const onCreateDNC = /* GraphQL */ `
  subscription OnCreateDNC($filter: ModelSubscriptionDNCFilterInput) {
    onCreateDNC(filter: $filter) {
      id
      tenant
      phoneNumber
      dncList
      createdAt
      updatedAt
    }
  }
`;
export const onUpdateDNC = /* GraphQL */ `
  subscription OnUpdateDNC($filter: ModelSubscriptionDNCFilterInput) {
    onUpdateDNC(filter: $filter) {
      id
      tenant
      phoneNumber
      dncList
      createdAt
      updatedAt
    }
  }
`;
export const onDeleteDNC = /* GraphQL */ `
  subscription OnDeleteDNC($filter: ModelSubscriptionDNCFilterInput) {
    onDeleteDNC(filter: $filter) {
      id
      tenant
      phoneNumber
      dncList
      createdAt
      updatedAt
    }
  }
`;
export const onCreateContactFieldSuppressionList = /* GraphQL */ `
  subscription OnCreateContactFieldSuppressionList(
    $filter: ModelSubscriptionContactFieldSuppressionListFilterInput
  ) {
    onCreateContactFieldSuppressionList(filter: $filter) {
      id
      tenant
      name
      contactField
      fields {
        items {
          id
          tenant
          contactFieldValue
          contactFieldSuppressionList
          createdAt
          updatedAt
        }
        nextToken
      }
      createdAt
      updatedAt
    }
  }
`;
export const onUpdateContactFieldSuppressionList = /* GraphQL */ `
  subscription OnUpdateContactFieldSuppressionList(
    $filter: ModelSubscriptionContactFieldSuppressionListFilterInput
  ) {
    onUpdateContactFieldSuppressionList(filter: $filter) {
      id
      tenant
      name
      contactField
      fields {
        items {
          id
          tenant
          contactFieldValue
          contactFieldSuppressionList
          createdAt
          updatedAt
        }
        nextToken
      }
      createdAt
      updatedAt
    }
  }
`;
export const onDeleteContactFieldSuppressionList = /* GraphQL */ `
  subscription OnDeleteContactFieldSuppressionList(
    $filter: ModelSubscriptionContactFieldSuppressionListFilterInput
  ) {
    onDeleteContactFieldSuppressionList(filter: $filter) {
      id
      tenant
      name
      contactField
      fields {
        items {
          id
          tenant
          contactFieldValue
          contactFieldSuppressionList
          createdAt
          updatedAt
        }
        nextToken
      }
      createdAt
      updatedAt
    }
  }
`;
export const onCreateContactFieldSuppression = /* GraphQL */ `
  subscription OnCreateContactFieldSuppression(
    $filter: ModelSubscriptionContactFieldSuppressionFilterInput
  ) {
    onCreateContactFieldSuppression(filter: $filter) {
      id
      tenant
      contactFieldValue
      contactFieldSuppressionList
      createdAt
      updatedAt
    }
  }
`;
export const onUpdateContactFieldSuppression = /* GraphQL */ `
  subscription OnUpdateContactFieldSuppression(
    $filter: ModelSubscriptionContactFieldSuppressionFilterInput
  ) {
    onUpdateContactFieldSuppression(filter: $filter) {
      id
      tenant
      contactFieldValue
      contactFieldSuppressionList
      createdAt
      updatedAt
    }
  }
`;
export const onDeleteContactFieldSuppression = /* GraphQL */ `
  subscription OnDeleteContactFieldSuppression(
    $filter: ModelSubscriptionContactFieldSuppressionFilterInput
  ) {
    onDeleteContactFieldSuppression(filter: $filter) {
      id
      tenant
      contactFieldValue
      contactFieldSuppressionList
      createdAt
      updatedAt
    }
  }
`;
export const onCreateSuppression = /* GraphQL */ `
  subscription OnCreateSuppression(
    $filter: ModelSubscriptionSuppressionFilterInput
  ) {
    onCreateSuppression(filter: $filter) {
      id
      tenant
      name
      checks {
        activityLogQuerySuppression {
          query
          rawQuery
          threshold
          result
        }
        pocQuerySuppression {
          query
          rawQuery
          suppressIfWeekendAndCantCallOnWeekends
          result
        }
        restSuppression {
          endpoint
          method
          params {
            key
            value
            description
          }
          headers {
            key
            value
            description
          }
          auth {
            type
            info
          }
          response {
            path
            type
            value
            options
          }
          suppressOnError
          dispositionOnError
          result
        }
        dncDotComSuppression {
          scrub
          state
          numberReassignment
          knownLitigator
          reassignmentSince
          checkOnlyFresh
          result
        }
        dncListSuppressions {
          dncs
          result
        }
        contactFieldSuppressions {
          contactFieldSuppressions
          result
        }
      }
      updatedBy
      createdAt
      updatedAt
    }
  }
`;
export const onUpdateSuppression = /* GraphQL */ `
  subscription OnUpdateSuppression(
    $filter: ModelSubscriptionSuppressionFilterInput
  ) {
    onUpdateSuppression(filter: $filter) {
      id
      tenant
      name
      checks {
        activityLogQuerySuppression {
          query
          rawQuery
          threshold
          result
        }
        pocQuerySuppression {
          query
          rawQuery
          suppressIfWeekendAndCantCallOnWeekends
          result
        }
        restSuppression {
          endpoint
          method
          params {
            key
            value
            description
          }
          headers {
            key
            value
            description
          }
          auth {
            type
            info
          }
          response {
            path
            type
            value
            options
          }
          suppressOnError
          dispositionOnError
          result
        }
        dncDotComSuppression {
          scrub
          state
          numberReassignment
          knownLitigator
          reassignmentSince
          checkOnlyFresh
          result
        }
        dncListSuppressions {
          dncs
          result
        }
        contactFieldSuppressions {
          contactFieldSuppressions
          result
        }
      }
      updatedBy
      createdAt
      updatedAt
    }
  }
`;
export const onDeleteSuppression = /* GraphQL */ `
  subscription OnDeleteSuppression(
    $filter: ModelSubscriptionSuppressionFilterInput
  ) {
    onDeleteSuppression(filter: $filter) {
      id
      tenant
      name
      checks {
        activityLogQuerySuppression {
          query
          rawQuery
          threshold
          result
        }
        pocQuerySuppression {
          query
          rawQuery
          suppressIfWeekendAndCantCallOnWeekends
          result
        }
        restSuppression {
          endpoint
          method
          params {
            key
            value
            description
          }
          headers {
            key
            value
            description
          }
          auth {
            type
            info
          }
          response {
            path
            type
            value
            options
          }
          suppressOnError
          dispositionOnError
          result
        }
        dncDotComSuppression {
          scrub
          state
          numberReassignment
          knownLitigator
          reassignmentSince
          checkOnlyFresh
          result
        }
        dncListSuppressions {
          dncs
          result
        }
        contactFieldSuppressions {
          contactFieldSuppressions
          result
        }
      }
      updatedBy
      createdAt
      updatedAt
    }
  }
`;
export const onCreateContactFieldMeta = /* GraphQL */ `
  subscription OnCreateContactFieldMeta(
    $filter: ModelSubscriptionContactFieldMetaFilterInput
  ) {
    onCreateContactFieldMeta(filter: $filter) {
      id
      tenant
      contact
      field
      type
      poc {
        cell
        consent
        writtenConsent
        optOut
        preferred
        thirdParty
        dontCallOnWeekends
        callWindows {
          days
          tmz {
            offset
            dst
          }
          beginTime {
            hour
            minute
          }
          endTime {
            hour
            minute
          }
          callWindowQuery {
            field
            operator
            value
          }
          default
          order
        }
      }
      contactModel {
        id
        tenant
        externalId
        firstName
        lastName
        source
        phone
        cell
        email
        dateCreated
        address1
        address2
        city
        state
        zip
        country
        dnc
        updatedBy
        customFields
        expireDt
        outboundCallerId
        assignedAgent
        balances {
          id
          type
          amount
          age
        }
        timeZone
        timeZoneBounds {
          min {
            offset
            dst
          }
          max {
            offset
            dst
          }
        }
        type
        optOuts {
          voice
          sms
          email
        }
        optIns {
          voice
          sms
          email
        }
        attempts
        createdAt
        updatedAt
      }
      updatedBy
      createdAt
      updatedAt
    }
  }
`;
export const onUpdateContactFieldMeta = /* GraphQL */ `
  subscription OnUpdateContactFieldMeta(
    $filter: ModelSubscriptionContactFieldMetaFilterInput
  ) {
    onUpdateContactFieldMeta(filter: $filter) {
      id
      tenant
      contact
      field
      type
      poc {
        cell
        consent
        writtenConsent
        optOut
        preferred
        thirdParty
        dontCallOnWeekends
        callWindows {
          days
          tmz {
            offset
            dst
          }
          beginTime {
            hour
            minute
          }
          endTime {
            hour
            minute
          }
          callWindowQuery {
            field
            operator
            value
          }
          default
          order
        }
      }
      contactModel {
        id
        tenant
        externalId
        firstName
        lastName
        source
        phone
        cell
        email
        dateCreated
        address1
        address2
        city
        state
        zip
        country
        dnc
        updatedBy
        customFields
        expireDt
        outboundCallerId
        assignedAgent
        balances {
          id
          type
          amount
          age
        }
        timeZone
        timeZoneBounds {
          min {
            offset
            dst
          }
          max {
            offset
            dst
          }
        }
        type
        optOuts {
          voice
          sms
          email
        }
        optIns {
          voice
          sms
          email
        }
        attempts
        createdAt
        updatedAt
      }
      updatedBy
      createdAt
      updatedAt
    }
  }
`;
export const onDeleteContactFieldMeta = /* GraphQL */ `
  subscription OnDeleteContactFieldMeta(
    $filter: ModelSubscriptionContactFieldMetaFilterInput
  ) {
    onDeleteContactFieldMeta(filter: $filter) {
      id
      tenant
      contact
      field
      type
      poc {
        cell
        consent
        writtenConsent
        optOut
        preferred
        thirdParty
        dontCallOnWeekends
        callWindows {
          days
          tmz {
            offset
            dst
          }
          beginTime {
            hour
            minute
          }
          endTime {
            hour
            minute
          }
          callWindowQuery {
            field
            operator
            value
          }
          default
          order
        }
      }
      contactModel {
        id
        tenant
        externalId
        firstName
        lastName
        source
        phone
        cell
        email
        dateCreated
        address1
        address2
        city
        state
        zip
        country
        dnc
        updatedBy
        customFields
        expireDt
        outboundCallerId
        assignedAgent
        balances {
          id
          type
          amount
          age
        }
        timeZone
        timeZoneBounds {
          min {
            offset
            dst
          }
          max {
            offset
            dst
          }
        }
        type
        optOuts {
          voice
          sms
          email
        }
        optIns {
          voice
          sms
          email
        }
        attempts
        createdAt
        updatedAt
      }
      updatedBy
      createdAt
      updatedAt
    }
  }
`;
export const onCreateDailyLicenseCount = /* GraphQL */ `
  subscription OnCreateDailyLicenseCount(
    $filter: ModelSubscriptionDailyLicenseCountFilterInput
  ) {
    onCreateDailyLicenseCount(filter: $filter) {
      id
      ownerTenant
      tenant
      licenseType
      ncBusinessUnit
      Date
      LicenseCount
      SmsCount
      EmailCount
      createdAt
      updatedAt
    }
  }
`;
export const onUpdateDailyLicenseCount = /* GraphQL */ `
  subscription OnUpdateDailyLicenseCount(
    $filter: ModelSubscriptionDailyLicenseCountFilterInput
  ) {
    onUpdateDailyLicenseCount(filter: $filter) {
      id
      ownerTenant
      tenant
      licenseType
      ncBusinessUnit
      Date
      LicenseCount
      SmsCount
      EmailCount
      createdAt
      updatedAt
    }
  }
`;
export const onDeleteDailyLicenseCount = /* GraphQL */ `
  subscription OnDeleteDailyLicenseCount(
    $filter: ModelSubscriptionDailyLicenseCountFilterInput
  ) {
    onDeleteDailyLicenseCount(filter: $filter) {
      id
      ownerTenant
      tenant
      licenseType
      ncBusinessUnit
      Date
      LicenseCount
      SmsCount
      EmailCount
      createdAt
      updatedAt
    }
  }
`;
export const onCreateOAuthLookUp = /* GraphQL */ `
  subscription OnCreateOAuthLookUp(
    $filter: ModelSubscriptionOAuthLookUpFilterInput
  ) {
    onCreateOAuthLookUp(filter: $filter) {
      id
      clientSecret
      cognitoUserName
      cognitoPassword
      createdAt
      updatedAt
    }
  }
`;
export const onUpdateOAuthLookUp = /* GraphQL */ `
  subscription OnUpdateOAuthLookUp(
    $filter: ModelSubscriptionOAuthLookUpFilterInput
  ) {
    onUpdateOAuthLookUp(filter: $filter) {
      id
      clientSecret
      cognitoUserName
      cognitoPassword
      createdAt
      updatedAt
    }
  }
`;
export const onDeleteOAuthLookUp = /* GraphQL */ `
  subscription OnDeleteOAuthLookUp(
    $filter: ModelSubscriptionOAuthLookUpFilterInput
  ) {
    onDeleteOAuthLookUp(filter: $filter) {
      id
      clientSecret
      cognitoUserName
      cognitoPassword
      createdAt
      updatedAt
    }
  }
`;
export const onCreateCallbackConfiguration = /* GraphQL */ `
  subscription OnCreateCallbackConfiguration(
    $filter: ModelSubscriptionCallbackConfigurationFilterInput
  ) {
    onCreateCallbackConfiguration(filter: $filter) {
      id
      tenant
      name
      scriptName
      maxPerDay
      maxTotal
      maxDaysOut
      expireAfterDays
      createdAt
      updatedAt
    }
  }
`;
export const onUpdateCallbackConfiguration = /* GraphQL */ `
  subscription OnUpdateCallbackConfiguration(
    $filter: ModelSubscriptionCallbackConfigurationFilterInput
  ) {
    onUpdateCallbackConfiguration(filter: $filter) {
      id
      tenant
      name
      scriptName
      maxPerDay
      maxTotal
      maxDaysOut
      expireAfterDays
      createdAt
      updatedAt
    }
  }
`;
export const onDeleteCallbackConfiguration = /* GraphQL */ `
  subscription OnDeleteCallbackConfiguration(
    $filter: ModelSubscriptionCallbackConfigurationFilterInput
  ) {
    onDeleteCallbackConfiguration(filter: $filter) {
      id
      tenant
      name
      scriptName
      maxPerDay
      maxTotal
      maxDaysOut
      expireAfterDays
      createdAt
      updatedAt
    }
  }
`;
